<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("add") }} {{ $t("offer") }} &{{ $t("voucher") }}
      </div>

      <router-link class="btn-blue" to="promotions-and-offers"
        >{{ $t("promotionsandoffer") }} {{ $t("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="d-flex justify-content-start aling-items-center">
        <div class="d-flex align-items-center">
          <b-form-checkbox
            v-model="offerSelected"
            @change="toggleSelection('offer')"
            name="check-button"
            class="j-checkbox pb-0"
          ></b-form-checkbox>
          <label class="mb-0 mr-2">{{ $t("Offer") }}</label>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox
            v-model="voucherSelected"
            @change="toggleSelection('voucher')"
            name="check-button"
            class="j-checkbox pb-0"
          ></b-form-checkbox>
          <label class="mb-0 mr-2">{{ $t("Voucher") }}</label>
        </div>
      </div>

      <!-- offer -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Settings</h5>
          <div class="row">
            <div class="col-lg-6 col-xl-3 my-2">
              <!-- <div class="input-material">
                  <input v-model="offer.offer_title" name="offer_title" id="offer_title" v-validate="'required'"
                    placeholder="." type="text" @input="onChangeText($event, 'name')" />
                  <label>{{ $t("title") }}</label>
                </div> -->
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  v-model="offer.offer_title"
                  name="offer_title"
                  id="offer_title"
                  v-validate="'required'"
                  @input="onChangeText($event, 'name')"
                />
                <label>{{ $t("title") }}</label>
              </div>
              <p
                v-if="submitted && errors.has('offer_title')"
                class="error_message"
              >
                <span>{{ errors.first("offer_title") }}</span>
              </p>
            </div>
            <div class="col-lg-6 col-xl-3 my-2">
              <div class="input-material">
                <input
                  :disabled="offerSelected"
                  v-model="offer.offer_code"
                  placeholder="."
                  type="text"
                />
                <label>{{ $t("code") }}</label>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-2">
              <div
                class="dropdown-curve-container"
                v-if="titleName === 'Offer'"
              >
                <label
                  :class="
                    offer.selectedOfferGroupType &&
                    offer.selectedOfferGroupType.hasOwnProperty('ogt_id')
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                  >Offer Group Type</label
                >
                <div class>
                  <multiselect
                    v-model="offer.selectedOfferGroupType"
                    placeholder="Client"
                    :options="masterData.offerGroupTypes"
                    label="ogt_type_name"
                    track-by="ogt_id"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center my-2">
              <div class="d-flex align-items-center justify-content-left">
                <b-form-checkbox
                  class="ml-3 j-checkbox pb-0"
                  v-model="offer.os_is_active"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="ml-1">{{ "Active" }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- {{ start .date }} -->

            <div class="col-lg-3 col-md-6 col-12 my-2">
              <div class="input-material">
                <div class="add-datepicker custom-date">
                  <button
                    class="btn-clearDate"
                    v-if="offer.offer_start_date_time"
                    v-on:click="offer.offer_start_date_time = null"
                  >
                    ✖
                  </button>
                  <div class="d-flex align-items-center">
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="offer.offer_start_date_time"
                      type="date"
                      class="theme-custom-date-time w-100"
                      typeable
                      id="voucher_startdate"
                      name="voucher_startdate"
                      v-b-tooltip.hover
                      :title="$t('start_date_tooltip')"
                    >
                    </Datepicker>
                    <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                  </div>
                  <label :class="offer.offer_start_date_time ? 'active' : ''">{{
                    $t("startdate")
                  }}</label>
                </div>
              </div>
              <p class="text-danger">
                <!-- <span>{{ custom_errors.voucher_start_date_error }}</span> -->
              </p>
            </div>
            <!-- {{ end date }} -->
            <div class="col-lg-3 col-md-6 col-12 my-2">
              <div class="input-material">
                <div class="add-datepicker custom-date">
                  <button
                    class="btn-clearDate"
                    v-if="offer.offer_end_date_time"
                    v-on:click="offer.offer_end_date_time = null"
                  >
                    ✖
                  </button>
                  <div class="d-flex align-items-center">
                    <Datepicker
                      :monday-first="true"
                      ref="programaticOpen"
                      v-model="offer.offer_end_date_time"
                      type="date"
                      class="theme-custom-date-time w-100"
                      typeable
                      id="voucher_startdate"
                      name="voucher_startdate"
                      v-b-tooltip.hover
                      :title="$t('end_date_tooltip')"
                    >
                    </Datepicker>
                    <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                  </div>
                  <label :class="offer.offer_end_date_time ? 'active' : ''">{{
                    $t("enddate")
                  }}</label>
                </div>
              </div>
              <p class="text-danger">
                <!-- <span>{{ custom_errors.voucher_start_date_error }}</span> -->
              </p>
            </div>
            <!-- {{ start time }} -->
            <div class="col-lg-6 col-xl-3 my-2 custom-timepicker">
              <div class="d-flex justify-content-center align-items-center">
                <vue-timepicker
                  manual-input
                  v-model="offer.offer_start_time"
                  id="starttime"
                  name="starttime"
                  :placeholder="$tc('starttime')"
                  format="HH:mm"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  v-b-tooltip.hover
                  :title="$t('start_time')"
                ></vue-timepicker>
                <!--Tooltip :title="$t('offer_start_time')" /-->
              </div>
            </div>
            <!-- {{ end time }} -->
            <div class="col-lg-6 col-xl-3 my-2 custom-timepicker">
              <div class="d-flex justify-content-center align-items-center">
                <vue-timepicker
                  manual-input
                  v-model="offer.offer_end_time"
                  id="endtime"
                  name="endtime"
                  :placeholder="$tc('endtime')"
                  format="HH:mm"
                  class="time_picker"
                  input-width="100%"
                  auto-scroll
                  lazy
                  v-b-tooltip.hover
                  :title="$t('end_time')"
                ></vue-timepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-3 my-2">
              <div class="input-material">
                <input
                  v-model="offer.offer_description_text"
                  placeholder="."
                  type="text"
                />
                <label>{{ $t("description") }}</label>
              </div>
            </div>
            <div v-if="offerSelected" class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.is_offer_auth_required"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Authentication Required</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="titleName !== 'Offer'">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.is_redemption"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Is Redemption</span>
              </div>
            </div>
            <div v-if="offerSelected" class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.visible_on_web"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{
                  $t("Visible On Website")
                }}</span>
              </div>
            </div>
            <div v-if="offerSelected" class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.is_package_offer"
                  unchecked-value="N"
                  value="Y"
                  @change="handlePackageOfferChange($event)"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Package Offer") }}</span>
              </div>
            </div>
            <div v-if="offerSelected" class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.report_offer"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Report Offer") }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.customers_only"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{
                  $t("Registered Customer only")
                }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offer.auto_apply"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Auto Apply") }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="voucherSelected">
              <div class="d-flex align-items-center">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.is_dynamic_voucher" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Dynamic Voucher") }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- offer content -->
      <section class="my-2" v-if="titleName === 'Offer'">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Content Configuration</h5>

          <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
            <div class="bn-tabs-nav mb-2">
              <button
                v-for="(
                  Content, ContentIndex
                ) in offerContent.offerContentArray"
                :key="ContentIndex"
                :class="[
                  'btn-tab-title',
                  { active: ContentIndex == offerContent.activeIndex },
                ]"
                @click.prevent.stop="onChangeTabHandler($event, ContentIndex)"
              >
                <strong>
                  <span
                    :class="
                      Content.langauge.toLowerCase() !== 'english'
                        ? offerContent.notempty[ContentIndex]
                          ? ''
                          : 'text-danger'
                        : ''
                    "
                    >{{ Content.langauge }}</span
                  >
                </strong>
              </button>
            </div>
            <div class="bn-tabs-content">
              <div
                v-for="(
                  Content, ContentIndex
                ) in offerContent.offerContentArray"
                :key="ContentIndex"
              >
                <div v-if="ContentIndex === offerContent.activeIndex">
                  <div class="row">
                    <div class="col-lg-6 col-xl-4 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input
                            placeholder="."
                            type="text"
                            v-model="Content.offer_title"
                            name="offer_content_title"
                            id="offer_content_title"
                            @input="CheckEmptyContent(Content, ContentIndex)"
                            v-validate="
                              Content.langauge.toLowerCase() === 'english'
                                ? 'required'
                                : ''
                            "
                            v-b-tooltip.hover
                            :title="$t('offer_content_title')"
                          />
                          <label>
                            {{ $t("title") }} ({{ $t("optional") }})</label
                          >
                        </div>
                      </div>
                      <p class="error_message">
                        <span
                          v-if="submitted && errors.has('offer_content_title')"
                          >{{ errors.first("offer_content_title") }}</span
                        >
                      </p>
                    </div>

                    <!-- <div
                        class="col-lg-6 col-xl-6 align-self-center"
                        v-if="false"
                      >
                        <div class="d-flex align-items-center">
                          <div class="input-material">
                            <input
                              placeholder="."
                              type="text"
                              v-model="Content.offer_description"
                              name="offer_content_desc"
                              id="offer_content_desc"
                              @input="CheckEmptyContent(Content, ContentIndex)"
                              v-b-tooltip.hover
                              :title="$t('offer_content_desc')"
                            />
                            <label
                              >{{ $t("description") }} ({{
                                $t("optional")
                              }})</label
                            >
                          </div>
                        </div>
                        <p class="error_message">
                          <span v-if="submitted && errors.has('offerdesc')">{{
                            errors.first("offerdesc")
                          }}</span>
                        </p>
                      </div> -->

                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="row align-self-center">
                        <div class="col-10">
                          <label
                            class="material-file-upload"
                            @click.prevent.stop="
                              setModalData(
                                offerContent.banner_image_height,
                                offerContent.banner_image_width,
                                ContentIndex,
                                1
                              )
                            "
                          >
                            <div class="label"></div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate">
                                {{
                                  Content.offer_banner_image
                                    ? Content.offer_banner_image
                                    : "Banner Image"
                                }}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div class="col-1 mt-1">
                          <img
                            width="40"
                            height="40"
                            class="rounded c-pointer img-preview"
                            @click="
                              openImageModal('', Content.offer_banner_image)
                            "
                            :src="_GetImagePath(Content.offer_banner_image)"
                            v-if="Content.offer_banner_image"
                          />
                          <img
                            v-else
                            width="35"
                            height="35"
                            class="rounded"
                            alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="row align-self-center">
                        <div class="col-10">
                          <label
                            class="material-file-upload"
                            @click.prevent.stop="
                              setModalData(
                                offerContent.poster_image_height,
                                offerContent.poster_image_width,
                                ContentIndex,
                                2
                              )
                            "
                          >
                            <div class="label"></div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate">
                                {{
                                  Content.offer_poster_image
                                    ? Content.offer_poster_image
                                    : "Poster Image"
                                }}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div class="col-1 mt-1">
                          <img
                            width="40"
                            height="40"
                            class="rounded c-pointer img-preview"
                            @click="
                              openImageModal('', Content.offer_poster_image)
                            "
                            :src="_GetImagePath(Content.offer_poster_image)"
                            v-if="Content.offer_poster_image"
                          />
                          <img
                            v-else
                            width="35"
                            height="35"
                            class="rounded"
                            alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      class="col-lg-12 align-self-center mb-4 descriptionEditor"
                    >
                      <div
                        class="descriptionSection font-weight-bold fs-14 mb-3"
                      >
                        Description
                      </div>
                      <div class="" v-if="offerContent.isEdit">
                        <vue-editor
                          v-model="Content.offer_description"
                          name="page"
                          id="page"
                        ></vue-editor>
                      </div>
                      <div
                        class="input-material-textarea"
                        v-else-if="
                          offerContent.isEditHtml && !offerContent.isEdit
                        "
                      >
                        <textarea
                          id="htmlContent"
                          name="htmlContent"
                          @input="
                            onChangeTranslationInput(
                              $event,
                              Content,
                              ContentIndex,
                              'offer_description'
                            )
                          "
                          v-model="Content.offer_description"
                          placeholder="Description"
                          class="htmlContent"
                        />
                      </div>
                      <div class="ql-snow" v-else>
                        <div
                          class="ql-editor"
                          v-html="Content.offer_description"
                          v-if="Content.offer_description"
                        ></div>
                        <div
                          class="ql-editor text-center"
                          v-else
                          style="min-height: 33px"
                        >
                          No Content
                        </div>
                      </div>
                      <vue-editor style="display: none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="row greyBackground p-2 r mx-2">
            <div class="col-11 bg-white py-2">
              <div
                v-for="(
                  signageItem, signageItemIndex
                ) in signageImageData.signageContainer"
                :key="signageItemIndex + 'SignageContainer'"
                class="col-md-12 mb-3"
              >
                <div class="row">
                  <div class="col-3 pl-0">
                    <div class="input-material">
                      <input
                        type="number"
                        v-model="signageItem.width"
                        :disabled="signageItemIndex < 2"
                        placeholder="Set Width"
                      />
                    </div>
                  </div>
                  <div class="col-3 pl-0">
                    <div class="input-material">
                      <input
                        type="number"
                        v-model="signageItem.height"
                        :disabled="signageItemIndex < 2"
                        placeholder="Set Height"
                      />
                    </div>
                  </div>
                  <div class="col-3 pl-0">
                    <label
                      class="material-file-upload c-pointer"
                      @click.prevent.stop="
                        setModalData(
                          signageItem.height,
                          signageItem.width,
                          signageItemIndex,
                          3
                        )
                      "
                    >
                      <div
                        class="label"
                        v-bind:class="{
                          'shift-up':
                            signageItem.imageUrl &&
                            signageItem.imageUrl.length > 0,
                        }"
                      >
                        <div class="text-truncate">
                          Signage Image {{ signageItemIndex + 1 }}
                        </div>
                      </div>
                      <div class="uploaded-file-name">
                        <div class="text-truncate pt-2">
                          {{ signageItem.imageUrl }}
                        </div>
                      </div>
                    </label>
                  </div>

                  <div
                    class="col-2 align-self-start"
                    v-if="signageItem.imageUrl"
                  >
                    <ImagePreviewer
                      :img="_GetImagePath(signageItem.imageUrl)"
                      :clickFunc="
                        () => {
                          openImageModal(
                            'Signage ' + `(${signageItem.imageUrl})`,
                            signageItem.imageUrl
                          );
                        }
                      "
                    />
                    <img
                      v-if="signageItem.imageUrl"
                      src="@/assets/img/icons/download.svg"
                      height="25"
                      width="25"
                      class="rounded cursor-pointer"
                      @click="
                        downloadImageSignage(signageItem, signageItemIndex)
                      "
                    />
                    <img
                      v-if="signageItem.imageUrl"
                      src="@/assets/img/icons/trash.svg"
                      height="25"
                      width="25"
                      class="rounded cursor-pointer"
                      @click="deleteImageSignage(signageItemIndex)"
                    />
                    <!-- <img
                          src="@/assets/img/icons/question.svg"
                          height="20"
                          width="20"
                          class="ml-2"
                          v-b-tooltip.hover
                          :title="
                            `Upload Artwork for the ${MovieContent.langauge} language`
                          "
                        /> -->
                  </div>
                  <div class="col-1" v-if="signageItemIndex > 1">
                    <img
                      class="rounded cursor-pointer"
                      @click.prevent.stop="removeSignage(signageItemIndex)"
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-1 greyBackground d-flex justify-content-center align-items-center border-left"
            >
              <button
                @click.prevent.stop="addSignageData()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- voucher setting -->
      <section v-if="voucherSelected" class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Voucher Settings</h5>
          <div class="row mb-2" style="height: 25px" v-if="offer.is_dynamic_voucher == 'N'">
            <div class="col-lg-12 col-xl-12 align-self-center my-2">
              <div class="d-flex align-items-center mb-2">
                <b-form-checkbox
                  class="j-checkbox pb-0"
                  v-model="voucherSettting.is_generate_multiple"
                ></b-form-checkbox>
                <span class="ml-1">{{ $t("generatemultiplecode") }}</span>
              </div>
            </div>
          </div>

          <b-collapse v-model="voucherSettting.is_generate_multiple" v-if="offer.is_dynamic_voucher == 'N'">
            <div class="rounded-10 p-3 mb-2" style="background-color: white">
              <div class="row">
                <div class="col-md-2 my-2">
                  <div class="input-material">
                    <input
                      v-model="voucherSettting.total_vouchers"
                      placeholder="."
                      type="text"
                    />
                    <label>{{ $t("total") }} {{ $t("number") }}</label>
                  </div>
                </div>

                <div class="col-md-2 my-2">
                  <div class="input-material">
                    <input
                      v-model="voucherSettting.voucher_prefix"
                      placeholder="."
                      type="text"
                    />
                    <label>{{ $t("enterPrefix") }}</label>
                  </div>
                </div>

                <div class="col-md-3 align-self-center my-2">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      class="j-checkbox pb-0"
                      v-model="voucherSettting.is_random"
                    ></b-form-checkbox>
                    <span class="ml-3">{{ $t("random") }}</span>
                  </div>
                </div>
                <div class="col-md-2 align-self-center my-2">
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      :checked="!voucherSettting.is_random"
                      @change="handleSequenceClick($event)"
                      class="j-checkbox"
                    ></b-form-checkbox>
                    <span class="ml-3">{{ $t("sequence") }}</span>
                  </div>
                </div>

                <div v-if="voucherSettting.is_random" class="col-md-2 mb-1">
                  <div class="input-material">
                    <input
                      v-model="voucherSettting.code_length"
                      placeholder="."
                      type="number"
                    />
                    <label>{{ $t("codelength") }}</label>
                  </div>
                </div>

                <div v-if="!voucherSettting.is_random" class="col-md-3 mb-1">
                  <div class="input-material">
                    <input
                      v-model="voucherSettting.sequence_start"
                      placeholder="."
                      type="number"
                    />
                    <label>{{ $t("sequence") }} {{ $t("start") }}</label>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>

          <div class="row col-12" style="margin-left: 1px">
            <div class="align-self-center">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionperPatron") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucherSettting.oc_redemptions_per_patron"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="align-self-center">
              <div class="d-flex align-items-center">
                <span>Total {{ $tc("redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="voucherSettting.oc_total_redemptions"
                    type="number"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- offer Cinema Configuration -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 px-2 mb-2">
          <h5 class="heading">Applicable Cinemas</h5>

          <div class="d-flex align-self-center ml-3">
            <div class="d-flex">
              <b-form-checkbox
                class="j-checkbox pb-0 ml-3"
                unchecked-value="N"
                value="Y"
                v-model="cinemaSettingsSection.isCinemaSettingsApplicable"
                @change="handleApplicableCinemaSettings($event)"
              ></b-form-checkbox>
              <div>
                {{ $t("selectcinemasclassesntickettypes") }}
              </div>
            </div>
            <div
              v-if="cinemaSettingsSection.isCinemaSettingsApplicable == 'Y'"
              class="d-flex ml-2"
            >
              <b-form-checkbox
                class="j-checkbox pb-0 ml-3"
                unchecked-value="Y"
                value="N"
                v-model="cinemaSettingsSection.allCinemaRowNotApplicableStatus"
                @change="handleAllRowNotApplicableStatus($event)"
              ></b-form-checkbox>
              <div>
                {{ $t("notapplicabletocinemas") }}
              </div>
            </div>
          </div>
          <template v-if="cinemaSettingsSection.cinemaSettings.length">
            <div
              class="row greyBackground my-2 px-2 py-2 mx-2"
              v-for="(
                settingsObj, settingsIndex
              ) in cinemaSettingsSection.cinemaSettings"
              :key="settingsIndex"
            >
              <div class="col-11">
                <div class="row bg-white">
                  <div
                    class="col-12 d-flex align-items-center py-2"
                    v-if="offer.is_package_offer == 'N'"
                  >
                    <div class="d-flex align-items-center">
                      <span class="ml-1">Not Applicable </span>
                      <b-form-checkbox
                        v-model="settingsObj.is_settings_applicable"
                        unchecked-value="Y"
                        value="N"
                        :disabled="true"
                        class="ml-2 j-checkbox pb-0"
                        @change="
                          handleScreenSeatData(
                            settingsIndex,
                            'applicableKey',
                            $event
                          )
                        "
                      ></b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <multiselect
                      :options="settingsObj.allowedCinemaList"
                      v-model="settingsObj.selectedCinema"
                      :placeholder="$tc('Cinemas')"
                      label="cine_name"
                      :multiple="true"
                      :close-on-select="false"
                      track-by="cine_id"
                      @select="
                        updateRejectedCinemaIds(settingsIndex, $event, 'add')
                      "
                      @remove="
                        updateRejectedCinemaIds(settingsIndex, $event, 'remove')
                      "
                      @input="updateScreenListCinemaWise($event, settingsIndex)"
                    ></multiselect>
                  </div>

                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          settingsObj.selectedScreens.length
                            ? 'shift-up'
                            : 'font-weight-bold'
                        "
                      >
                        {{ $tc("screens", 1) }}</label
                      >
                      <!-- <multiselect v-model="settingsObj.selectedScreens" :options="settingsObj.cinemaScreens"
                        open-direction="bottom" :close-on-select="false" placeholder="Screens" label="screen_name"
                        track-by="screen_id" :multiple='true' @input="handleCinemaScreenChange(settingsIndex, $event)">
                      </multiselect> -->
                      <multiselect
                        v-model="settingsObj.selectedScreens"
                        :options="settingsObj.allowedScreenList"
                        :multiple="true"
                        group-values="screenData"
                        group-label="cine_name"
                        :group-select="true"
                        :disabled="
                          settingsObj.is_settings_applicable == 'N' &&
                          settingsObj.selectedSeatTypes.length > 0
                        "
                        :searchable="true"
                        :showLabels="false"
                        label="screen_name"
                        placeholder=""
                        track-by="screen_id"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          settingsObj.selectedSeatTypes.length
                            ? 'shift-up'
                            : 'font-weight-bold'
                        "
                      >
                        Seat Types</label
                      >
                      <multiselect
                        v-model="settingsObj.selectedSeatTypes"
                        :options="masterData.seatGroups"
                        :disabled="
                          settingsObj.is_settings_applicable == 'N' &&
                          settingsObj.selectedScreens.length > 0
                        "
                        open-direction="bottom"
                        :close-on-select="false"
                        placeholder="Seat Groups"
                        label="sstg_name"
                        track-by="sstg_id"
                        :multiple="true"
                      >
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label
                        :class="
                          settingsObj.selectedTickets.length
                            ? 'shift-up'
                            : 'font-weight-bold'
                        "
                      >
                        Ticket Types</label
                      >
                      <multiselect
                        v-model="settingsObj.selectedTickets"
                        :options="masterData.ticketTypesData"
                        open-direction="bottom"
                        :close-on-select="false"
                        placeholder="Tickets"
                        label="tt_name"
                        track-by="tt_id"
                        :multiple="true"
                        @input="handleCinemaScreenChange(settingsIndex, $event)"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center"
              >
                <button
                  class="btn-transparent"
                  @click="handleCinemaSettings('remove', settingsIndex)"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="30"
                    width="30"
                  />
                </button>
              </div>
            </div>
            <div class="row justify-content-center">
              <button
                class="btn-transparent mb-3"
                @click="handleCinemaSettings('add')"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
            </div>
          </template>
        </div>
      </section>

      <!-- offer Movie Configuration -->
      <section class="my-2">
        <div
          class="section-border container rounded-10 col-12 p-3 mb-2 d-flex flex-wrap"
        >
          <h5 class="heading">Applicable Movies</h5>

          <div class="col-lg-12 py-2">
            <div class="row py-2">
              <div
                class="col-lg-4 d-flex align-items-center"
                style="margin-left: 12px"
              >
                <div class="d-flex align-items-center">
                  <b-form-checkbox
                    v-model="
                      offerMovieConfiguration.os_is_foreign_movie_applicable
                    "
                    unchecked-value="N"
                    value="Y"
                    class="j-checkbox pb-0"
                  ></b-form-checkbox>
                  <span class="ml-1"
                    >Is Applicable On
                    {{ showForeignMovieSection ? "Indian" : "Foreign" }}
                    Movies</span
                  >
                </div>
              </div>
              <div class="col-12 col-lg-6 py-2">
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      offerMovieConfiguration.selectedMovieFormats.length > 0
                        ? 'shift-up'
                        : 'font-weight-bold'
                    "
                    >Applicable Movie Formats</label
                  >
                  <multiselect
                    v-model="offerMovieConfiguration.selectedMovieFormats"
                    :options="masterData.movieFormats"
                    :close-on-select="false"
                    placeholder=""
                    label="mf_name"
                    :multiple="true"
                    track-by="mf_id"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 mb-2 ml-3 rounded-10">
            <div class="row">
              <div class="col-5">
                <div class="row py-2 section-border col-12">
                  <h5 class="subheading-scoped">Show Time Between</h5>
                  <div class="col-lg-6 mt-2 custom-timepicker">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <vue-timepicker
                        manual-input
                        v-model="offerMovieConfiguration.os_time_limit_start"
                        id="osmoviestarttime"
                        name="osmoviestarttime"
                        placeholder="Start Time"
                        format="HH:mm"
                        class="time_picker"
                        input-width="100%"
                        auto-scroll
                        lazy
                        v-b-tooltip.hover
                        :title="$t('Start Time Validity')"
                      ></vue-timepicker>
                      <!--Tooltip :title="$t('offer_start_time')" /-->
                    </div>
                  </div>
                  <div class="col-lg-6 mt-2 custom-timepicker">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <vue-timepicker
                        manual-input
                        v-model="offerMovieConfiguration.os_time_limit_end"
                        id="osmovieendtime"
                        name="osmovieendtime"
                        placeholder="End Time"
                        format="HH:mm"
                        class="time_picker"
                        input-width="100%"
                        auto-scroll
                        lazy
                        v-b-tooltip.hover
                        title="End Time Validity"
                      ></vue-timepicker>
                      <!--Tooltip :title="$t('offer_start_time')" /-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="row py-2 section-border">
                  <h5 class="subheading-scoped">Select Movies</h5>
                  <div class="col-12 col-lg-6 d-flex align-items-center mt-2">
                    <div
                      class="d-flex align-items-center"
                      style="margin-left: -20px"
                    >
                      <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                      <b-form-radio
                        value="movies_applicable"
                        class="j-radio ml-2 pb-0"
                        v-model="
                          offerMovieConfiguration.movies_applicable_status
                        "
                        @change="
                          handleMovieApplicableChange('movies_applicable')
                        "
                      >
                      </b-form-radio>
                      <div>
                        <span style="text-transform: capitalize"
                          >Applicable</span
                        >
                      </div>
                      <!---strong class="mx-3">OR</strong---->

                      <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                      <b-form-radio
                        value="movies_not_applicable"
                        class="j-radio ml-2 pb-0"
                        v-model="
                          offerMovieConfiguration.movies_applicable_status
                        "
                        @change="
                          handleMovieApplicableChange('movies_not_applicable')
                        "
                      >
                        <div>
                          <span>Not Applicable</span>
                        </div>
                      </b-form-radio>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 align-self-center mt-2">
                    <custommultiselect
                      :options="masterData.movieList"
                      v-model="
                        offerMovieConfiguration.selectedParticaularMovies
                      "
                      :placeholder="
                        $t(
                          offerMovieConfiguration.os_is_movie_applicable == 'Y'
                            ? 'Applicable Movies'
                            : 'Not Applicable Movies'
                        )
                      "
                      label="movie"
                      isSingleId="md_id"
                      :close-on-select="false"
                      :multiple="true"
                      track-by="md_id"
                    >
                    </custommultiselect>
                  </div>
                  <!-- <div class="row section-border col-12 col-lg-12">

                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="row px-2 mb-2" v-if="false">
            <div class="col-12 col-lg-6 mb-2 py-2">
              <div class="mb-2">
                {{ $t("offer_applicable_between_time") }}
              </div>
              <div class="d-flex">
                <div class="col-lg-6 custom-timepicker pl-0">
                  <div class="d-flex justify-content-center align-items-center">
                    <vue-timepicker
                      manual-input
                      id="o_start_show_time"
                      name="o_start_show_time"
                      :placeholder="$tc('fromtime')"
                      format="HH:mm"
                      class="time_picker"
                      input-width="100%"
                      v-model="offerMovieConfiguration.start_show_time"
                      auto-scroll
                      lazy
                      v-b-tooltip.hover
                      :title="$t('o_start_show_time')"
                    ></vue-timepicker>
                    <!--Tooltip :title="$t('o_start_show_time')" /-->
                  </div>
                </div>

                <div class="col-lg-6 custom-timepicker">
                  <div class="d-flex justify-content-center align-items-center">
                    <vue-timepicker
                      manual-input
                      id="o_end_show_time"
                      name="o_end_show_time"
                      v-model="offerMovieConfiguration.end_show_time"
                      :placeholder="$tc('totime')"
                      format="HH:mm"
                      class="time_picker"
                      input-width="100%"
                      auto-scroll
                      lazy
                      v-b-tooltip.hover
                      :title="$t('o_end_show_time')"
                    ></vue-timepicker>
                    <!--Tooltip :title="$t('o_end_show_time')" /-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- offer Days Configuration -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3">
          <h5 class="heading">Days Configuration</h5>
          <div class="col-lg-12 col-xl-12 align-self-center mt-3">
            <div class="row px-2">
              {{ $t("show") }} {{ $t("days") }}:
              <b-form-checkbox
                v-for="(
                  weekdaysLoop, weekdaysKey
                ) in offerDaysConfiguration.weekDays"
                :key="weekdaysKey"
                v-model="offerDaysConfiguration.weekDays[weekdaysKey]"
                value="Y"
                unchecked-value="N"
                class="j-checkbox mx-2 mb-2 pb-0"
                @change="onChangeWeekdays($event, weekdaysKey)"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span
                v-if="submitted && offerDaysConfiguration.TrueFalseCount == 7"
                >{{ $t("pleaseSelectAtLeastOneday") }}
              </span>
            </p>
          </div>
        </div>
      </section>

      <!-- osther setting  -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Other Settings</h5>

          <div class="row mb-0">
            <div
              v-if="offerSelected"
              class="col-lg-6 col-xl-2 my-3 d-flex align-items-center"
            >
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="offerSettingConfiguration.is_bank_offer"
                  unchecked-value="N"
                  value="Y"
                  @change="onSelectBankOffer($event)"
                ></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("is_bank_offer") }}</span>
              </div>
            </div>
            <div
              class="col-lg-6 col-xl-3 my-3"
              v-if="offerSettingConfiguration.is_bank_offer == 'Y'"
            >
              <div class="d-flex align-items-center">
                <custommultiselect
                  v-model="
                    offerSettingConfiguration.bankDetails['selectedBank']
                  "
                  :options="masterData.activeBankList"
                  :placeholder="$tc('Bank')"
                  label="bank_name"
                  isSingleId="bank_id"
                  :multiple="false"
                  track-by="bank_id"
                  @select="onSelectBankv2($event, 'ADD')"
                >
                </custommultiselect>
              </div>
              <p
                v-if="
                  submitted &&
                  offerSettingConfiguration.is_bank_offer == 'Y' &&
                  !offerSettingConfiguration.bankDetails['bank_id']
                "
                class="error_message"
              >
                <span>{{ $tc("please") }} {{ $tc("selectBank") }}.</span>
              </p>
            </div>
            <div
              class="col-lg-6 col-xl-3 my-3"
              v-if="offerSettingConfiguration.is_bank_offer == 'Y'"
            >
              <div class="d-flex align-items-center">
                <custommultiselect
                  v-model="
                    offerSettingConfiguration.bankDetails['selectedCard']
                  "
                  :options="masterData.activeBankCardList"
                  :placeholder="$tc('Card Type')"
                  label="card_type"
                  isSingleId="card_id"
                  :multiple="true"
                  :close-on-select="false"
                  track-by="card_id"
                ></custommultiselect>
              </div>
              <p
                v-if="
                  submitted &&
                  offerSettingConfiguration.is_bank_offer == 'Y' &&
                  !offerSettingConfiguration.bankDetails['card_type_ids']
                "
                class="error_message"
              >
                <span>{{ $tc("please") }} {{ $tc("selectcardtype") }}.</span>
              </p>
            </div>
            <div
              class="col-lg-6 col-xl-3 my-3"
              v-if="offerSettingConfiguration.is_bank_offer == 'Y'"
            ></div>
            <!-- <div class="row" style="height: 35px"> -->
            <div class="col-lg-4 col-xl-3 my-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    offerSettingConfiguration.clientShareSettings.client &&
                    String(offerSettingConfiguration.clientShareSettings.client)
                      .length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $tc("client") }}</label
                >
                <div class>
                  <multiselect
                    v-model="
                      offerSettingConfiguration.clientShareSettings.client
                    "
                    :placeholder="$tc('client')"
                    :options="masterData.clientList"
                    label="client_name"
                    track-by="client_id"
                    :multiple="false"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-2">
              <div class="d-flex align-items-center justify-content-center">
                <span>{{ $tc("share") }} {{ $tc("value") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="
                      offerSettingConfiguration.clientShareSettings
                        .client_share_value
                    "
                    name="share_value"
                    id="share_value"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 col-xl-2 align-self-center mb-2"
              v-if="!offerSelected"
            >
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="
                    offerSettingConfiguration.clientShareSettings
                      .is_prepaid_voucher
                  "
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Is Prepaid Voucher</span>
              </div>
            </div>
            <div
              class="col-lg-6 col-xl-2 align-self-center mb-2"
              v-if="
                offerSettingConfiguration.clientShareSettings
                  .is_prepaid_voucher == 'N'
              "
            >
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  v-model="
                    offerSettingConfiguration.clientShareSettings
                      .is_share_percentage
                  "
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Client Share Is Percentage</span>
              </div>
            </div>
          </div>
          <div v-if="isReportingFeeClient" class="row align-items-center">
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  @change="onChangeReporting($event, 'full')"
                  v-model="offerSettingConfiguration.report_full_amount"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Report full Amt.</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  @change="onChangeReporting($event, 'full_spcl')"
                  v-model="
                    offerSettingConfiguration.report_full_amount_special_rc
                  "
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold"
                  >Report full Amt. for Spl. RC</span
                >
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox
                  class="j-checkbox pb-0 ml-3"
                  @change="onChangeReporting($event, 'specific')"
                  v-model="offerSettingConfiguration.has_o_reporting_percent"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
                <span class="font-weight-bold">Report Specific Percent</span>
              </div>
            </div>
            <div
              class="col-lg-6 col-xl-3 my-3"
              v-if="offerSettingConfiguration.has_o_reporting_percent == 'Y'"
            >
              <div class="d-flex align-items-center justify-content-start">
                <span class="font-weight-bold">Reporting Percent</span>
                <div class="input-material-sm mx-2">
                  <input
                    style="text-align: right"
                    v-model="offerSettingConfiguration.o_reporting_percent"
                    name="dist_share_value"
                    id="dist_share_value"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Offer type  -->
      <section class="my-2">
        <div class="section-border container col-12 rounded-10 py-3 mb-2">
          <h5 class="heading">{{ titleName }} Types</h5>

          <div class="row mt-2">
            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('fixedDiscount')"
            >
              <b-form-radio
                value="fixedDiscount"
                class="j-radio"
                v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)"
              >
                <div>{{ $t("Fixed Discount") }}</div>
              </b-form-radio>
            </div>
            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('buyAndGetFreeTickets')"
            >
              <b-form-radio
                value="buyAndGetFreeTickets"
                class="j-radio"
                v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)"
              >
                <div>{{ $t("buyngetfreeticket") }}</div>
              </b-form-radio>
            </div>
            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('discount')">
              <b-form-radio
                class="j-radio"
                value="discount"
                v-model="offerTypes.selectedOfferType"
              >
                <div>{{ $t("discounts") }}</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('buyAndGetCombo')"
            >
              <b-form-radio
                value="buyAndGetCombo"
                class="j-radio"
                v-model="offerTypes.selectedOfferType"
              >
                <div>{{ $t("buyandgetcombo") }}</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('fixedPriceTicketFnb')"
            >
              <b-form-radio
                class="j-radio"
                value="fixedPriceTicketFnb"
                v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)"
              >
                <div>{{ $t("fixedPriceTicketFnb") }}</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('buyAndgetOffOnAnother')"
            >
              <b-form-radio
                class="j-radio"
                value="buyAndgetOffOnAnother"
                v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)"
              >
                <div>{{ $t("buyAndgetOffOnAnother") }}</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('loyalitycustomers')"
            >
              <b-form-radio
                class="j-radio"
                value="loyalitycustomers"
                v-model="offerTypes.selectedOfferType"
              >
                <div>{{ $t("loyalityOffers") }}</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('fnbItemDiscounts')"
            >
              <b-form-radio
                class="j-radio"
                value="fnbItemDiscounts"
                @change="onChangeOfferType($event)"
                v-model="offerTypes.selectedOfferType"
              >
                <div>{{ $t("fnbItemDiscounts") }}</div>
              </b-form-radio>
            </div>
            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('freeTickets')"
            >
              <b-form-radio
                class="j-radio"
                value="freeTickets"
                @change="onChangeOfferType($event)"
                v-model="offerTypes.selectedOfferType"
              >
                <div>Free Tickets</div>
              </b-form-radio>
            </div>

            <div
              class="mx-2 mb-2"
              v-if="checkOfferTypeAvailable('onlyFnbFixed')"
            >
              <b-form-radio
                class="j-radio"
                value="onlyFnbFixed"
                @change="onChangeOfferType($event)"
                v-model="offerTypes.selectedOfferType"
              >
                <div>Fixed Price Only FnB</div>
              </b-form-radio>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <!-- Fixed Discount-->
              <div
                class="offer-content-wrapper pt-3 pl-0"
                v-if="offerTypes.selectedOfferType == 'fixedDiscount'"
              >
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-12">
                        <div class="row mb-2">
                          <div class="col-lg-6 col-xl-3 my-3">
                            <div
                              class="d-flex align-items-center justify-content-start"
                            >
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-3"
                                :disabled="
                                  offerSettingConfiguration.is_bank_offer == 'Y'
                                "
                                v-model="offerTypes.is_employee_offer"
                                unchecked-value="N"
                                value="Y"
                                @change="onSelectEmployeeDiscount($event)"
                              ></b-form-checkbox>
                              <span class="">{{
                                $t("is_employee_offer")
                              }}</span>
                            </div>
                          </div>
                          <div
                            class="col-lg-12 col-xl-3 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("Offer Value :") }}
                              <div class="input-material mx-1">
                                <input
                                  style="text-align: right"
                                  name="discount_buy_value"
                                  id="discount_buy_value"
                                  v-validate="'required'"
                                  type="number"
                                  v-model="
                                    offerTypes.fixedDiscount.oc_discount_value
                                  "
                                  @input="
                                    ($event) => {
                                      offerTypes.fixedDiscount.oc_max_discount_amount =
                                        offerTypes.fixedDiscount.oc_discount_value;
                                    }
                                  "
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted && errors.has('discount_buy_value')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("discount_buy_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0"
                                v-model="
                                  offerTypes.fixedDiscount
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="number"
                                  name="max_discount_per_trans"
                                  id="max_discount_per_trans"
                                  v-validate="'required'"
                                  v-model="
                                    offerTypes.fixedDiscount
                                      .oc_max_discount_amount
                                  "
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted &&
                                errors.has('max_discount_per_trans')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-lg-6 col-xl-2 align-self-center ml-3 mb-2"
                      >
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            class="j-checkbox pb-0"
                            v-model="
                              offerTypes.fixedDiscount.min_amount_channel_wise
                            "
                            unchecked-value="N"
                            value="Y"
                            @change="onChangeChannelWise($event)"
                          ></b-form-checkbox>
                          {{ "Channel Wise" }}
                        </div>
                      </div>
                      <div class="col-lg-12 col-xl-2 mb-2 mx-0 px-0">
                        <div
                          class="d-flex align-items-center justify-content-center"
                        >
                          <span
                            v-if="
                              offerTypes.fixedDiscount
                                .min_amount_channel_wise == 'Y'
                            "
                            >{{ "Min. Ticket Amt." }}</span
                          >
                          <span v-else>{{ "Min. Bill Amt" }}</span>
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              v-model="
                                offerTypes.fixedDiscount.oc_min_ticket_price
                              "
                              type="number"
                              name="min_ticket_amount"
                              id="min_ticket_amount"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-lg-12 col-xl-2 mb-2 mx-0 px-0"
                        v-if="
                          offerTypes.fixedDiscount.min_amount_channel_wise ==
                          'Y'
                        "
                      >
                        <div
                          class="d-flex align-items-center justify-content-center"
                        >
                          {{ "Min Fnb Amt." }}
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              v-model="
                                offerTypes.fixedDiscount.oc_min_fnb_price
                              "
                              type="number"
                              name="min_fnb_amount"
                              id="min_fnb_amount"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Buy/Get free ticket-->
              <div
                class="offer-content-wrapper pl-0"
                style="padding-top: 20px"
                v-if="offerTypes.selectedOfferType == 'buyAndGetFreeTickets'"
              >
                <div class="row section-border mx-1 pt-2">
                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div class="d-flex align-items-center">
                      {{ $t("buy") }}
                      <div class="input-material-sm mx-1">
                        <input
                          style="text-align: right"
                          v-model="
                            offerTypes.buyAndGetFreeTickets.oc_buy_no_of_ticket
                          "
                          type="number"
                          name="buy_value"
                          id="buy_value"
                          v-validate="'required|numeric'"
                        />
                      </div>
                      {{ $t("get") }}
                      <div class="input-material-sm mx-2">
                        <input
                          v-model="
                            offerTypes.buyAndGetFreeTickets.oc_get_free_ticket
                          "
                          type="number"
                          name="get_value"
                          id="get_value"
                          v-validate="'required|numeric'"
                        />
                      </div>
                      {{ $t("ofticketsfree") }}
                    </div>
                    <p
                      v-if="
                        (submitted && errors.has('buy_value')) ||
                        (submitted && errors.has('get_value'))
                      "
                      class="error_message"
                    >
                      <span>{{
                        errors.first("buy_value") || errors.first("get_value")
                      }}</span>
                    </p>
                  </div>

                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      {{ $tc("minTicketAmount") }}
                      <div class="input-material-sm mx-2">
                        <input
                          style="text-align: right"
                          v-model="
                            offerTypes.buyAndGetFreeTickets.oc_min_ticket_price
                          "
                          type="number"
                          name="min_ticket_amount"
                          id="min_ticket_amount"
                          v-validate="'required|decimal'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('min_ticket_amount')"
                      class="error_message"
                    >
                      <span>{{ errors.first("min_ticket_amount") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div class="d-flex align-items-center">
                      {{ $t("maxfreeticketpertransaction") }}
                      <div class="input-material-sm mx-2">
                        <input
                          style="text-align: right"
                          v-model="
                            offerTypes.buyAndGetFreeTickets
                              .oc_max_no_of_ticket_per_transaction
                          "
                          type="number"
                          name="max_ticket"
                          id="max_ticket"
                          v-validate="'required|numeric'"
                        />
                      </div>
                    </div>
                    <p
                      v-if="submitted && errors.has('max_ticket')"
                      class="error_message"
                    >
                      <span>{{ errors.first("max_ticket") }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <!--Discount-->
              <div
                class="offer-content-wrapper pt-3 pl-0"
                v-if="offerTypes.selectedOfferType == 'discount'"
              >
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-11">
                        <div class="row">
                          <div
                            class="col-lg-12 col-xl-6 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("buy") }}
                              <div class="input-material-sm mx-1">
                                <input
                                  style="text-align: right"
                                  name="discount_buy_value"
                                  id="discount_buy_value"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  v-model="
                                    offerTypes.discount.oc_buy_no_of_ticket
                                  "
                                />
                              </div>
                              {{ $t("ticket_fnbitem") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="discount_get_value"
                                  id="discount_get_value"
                                  v-validate="'required|numeric'"
                                  v-model="
                                    offerTypes.discount.oc_discount_value
                                  "
                                  @input="handleMaxDiscount()"
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                (submitted &&
                                  errors.has('discount_buy_value')) ||
                                (submitted && errors.has('discount_get_value'))
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("discount_buy_value") ||
                                errors.first("discount_get_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0"
                                v-model="
                                  offerTypes.discount
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="max_discount_per_trans"
                                  id="max_discount_per_trans"
                                  v-validate="'required'"
                                  v-model="
                                    offerTypes.discount.oc_max_discount_amount
                                  "
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted &&
                                errors.has('max_discount_per_trans')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Loyality Program Offers-->
              <div
                class="offer-content-wrapper pt-3 pl-0"
                v-if="offerTypes.selectedOfferType == 'loyalitycustomers'"
              >
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-11">
                        <div class="row">
                          <div
                            class="col-lg-12 col-xl-6 align-self-center mb-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("buy") }}
                              <div class="input-material-sm mx-1">
                                <input
                                  style="text-align: right"
                                  name="discount_buy_value"
                                  id="discount_buy_value"
                                  v-validate="'required|numeric'"
                                  type="text"
                                  v-model="
                                    offerTypes.loyalityProgramOffer
                                      .oc_buy_no_of_ticket
                                  "
                                />
                              </div>
                              {{ $t("ticket_fnbitem") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="discount_get_value"
                                  id="discount_get_value"
                                  v-validate="'required|numeric'"
                                  v-model="
                                    offerTypes.loyalityProgramOffer
                                      .oc_discount_value
                                  "
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                (submitted &&
                                  errors.has('discount_buy_value')) ||
                                (submitted && errors.has('discount_get_value'))
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("discount_buy_value") ||
                                errors.first("discount_get_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0"
                                v-model="
                                  offerTypes.loyalityProgramOffer
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div
                            class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2"
                          >
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="max_discount_per_trans"
                                  id="max_discount_per_trans"
                                  v-validate="'required'"
                                  v-model="
                                    offerTypes.loyalityProgramOffer
                                      .oc_max_discount_amount
                                  "
                                />
                              </div>
                            </div>
                            <p
                              v-if="
                                submitted &&
                                errors.has('max_discount_per_trans')
                              "
                              class="error_message"
                            >
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Buy And Get Como-->
              <div
                class="offer-content-wrapper py-0 pl-0"
                v-if="offerTypes.selectedOfferType == 'buyAndGetCombo'"
              >
                <div class="row section-border p-2 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4 pl-0">
                    <div class="d-flex">
                      {{ $t("combinewith") }}:
                      <b-form-radio
                        value="fAndb"
                        class="j-radio ml-4"
                        v-model="offerTypes.buyAndGetCombo.offerApplicableAt"
                      >
                        <div>F&amp;B</div>
                      </b-form-radio>
                      <b-form-radio
                        value="boxOffice"
                        class="j-radio ml-3"
                        v-model="offerTypes.buyAndGetCombo.offerApplicableAt"
                      >
                        <div>{{ $t("boxoffice") }}</div>
                      </b-form-radio>
                    </div>
                  </div>
                  <div
                    class="col-12"
                    v-if="
                      offerTypes.buyAndGetCombo.offerApplicableAt === 'fAndb'
                    "
                  >
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 pl-0">
                        <div class="row mx-0 align-items-center">
                          <div class="mb-0">
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input
                              v-model="
                                offerTypes.buyAndGetCombo.F_And_B
                                  .oc_buy_item_count
                              "
                              type="text"
                              name="buy_fnb_combo"
                              id="buy_fnb_combo"
                              v-validate="'required|numeric'"
                            />
                          </div>

                          <div class="col-2">
                            <div class="dropdown-curve-container">
                              <label
                                :class="
                                  offerTypes.buyAndGetCombo.F_And_B
                                    .selectedBuyFnbItem &&
                                  offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.hasOwnProperty(
                                    'item_id'
                                  )
                                    ? 'shift-up'
                                    : ''
                                "
                                >{{ $tc("fnbitems") }}</label
                              >
                              <div>
                                <multiselect
                                  v-model="
                                    offerTypes.buyAndGetCombo.F_And_B
                                      .selectedBuyFnbItem
                                  "
                                  :options="masterData.fnbItems"
                                  :placeholder="$tc('fnbitems')"
                                  label="item_name"
                                  isSingleId="item_id"
                                  :multiple="false"
                                  track-by="item_id"
                                ></multiselect>
                              </div>
                            </div>
                          </div>
                          <span class="text-nowrap">{{ $t("get") }}</span>

                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              v-model="
                                offerTypes.buyAndGetCombo.F_And_B
                                  .oc_get_item_count
                              "
                              type="text"
                              name="get_fnb_combo"
                              id="get_fnb_combo"
                              v-validate="'required|numeric'"
                            />
                          </div>

                          <div class="col-2">
                            <div class="dropdown-curve-container">
                              <label
                                :class="
                                  offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.hasOwnProperty(
                                    'item_id'
                                  )
                                    ? 'shift-up'
                                    : 'font-weight-bold'
                                "
                                >{{ $tc("fnbitems") }}</label
                              >
                              <div>
                                <multiselect
                                  v-model="
                                    offerTypes.buyAndGetCombo.F_And_B
                                      .selectedGetFnbItem
                                  "
                                  :options="masterData.fnbItems"
                                  :placeholder="$tc('fnbitems')"
                                  label="item_name"
                                  isSingleId="item_id"
                                  :multiple="false"
                                  track-by="item_id"
                                ></multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <b-form-checkbox
                              class="j-checkbox pb-0 ml-3"
                              v-model="
                                offerTypes.buyAndGetCombo.F_And_B
                                  .oc_is_combo_free
                              "
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>
                            <span class="text-nowrap">Free</span>
                          </div>

                          <div
                            v-if="
                              offerTypes.buyAndGetCombo.F_And_B
                                .oc_is_combo_free === 'N'
                            "
                            style="display: flex"
                          >
                            <div class="d-flex align-items-center ml-3">
                              <span class="text-nowrap"
                                >&nbsp;{{ $t("offer") }} {{ $t("value") }}</span
                              >
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="free_combo_offer_value"
                                  id="free_combo_offer_value"
                                  v-validate="'required|decimal'"
                                  v-model="
                                    offerTypes.buyAndGetCombo.F_And_B
                                      .oc_discount_value
                                  "
                                />
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-3"
                                v-model="
                                  offerTypes.buyAndGetCombo.F_And_B
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                              ></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('buy_fnb_combo')) ||
                            errors.has('get_fnb_combo') ||
                            (offerTypes.buyAndGetCombo.F_And_B
                              .oc_is_combo_free === 'N' &&
                              errors.has('free_combo_offer_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("buy_fnb_combo") ||
                            errors.first("get_fnb_combo") ||
                            errors.first("free_combo_offer_value")
                          }}</span>
                        </p>
                        <p
                          v-else-if="
                            submitted &&
                            offerTypes.buyAndGetCombo.F_And_B
                              .oc_buy_item_count != null &&
                            !offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.hasOwnProperty(
                              'item_id'
                            )
                          "
                          class="error_message"
                        >
                          <span>Please select F&B item for Buy.</span>
                        </p>
                        <p
                          v-else-if="
                            submitted &&
                            offerTypes.buyAndGetCombo.F_And_B
                              .oc_get_item_count != null &&
                            !offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.hasOwnProperty(
                              'item_id'
                            )
                          "
                          class="error_message"
                        >
                          <span>Please select F&B item for Get.</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-12"
                    v-if="
                      offerTypes.buyAndGetCombo.offerApplicableAt ===
                      'boxOffice'
                    "
                  >
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 pl-0">
                        <div class="row mx-0 align-items-center">
                          <div>
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input
                              style="text-align: right"
                              v-model="
                                offerTypes.buyAndGetCombo.boxOffice
                                  .oc_buy_no_of_ticket
                              "
                              type="text"
                              name="buy_bo_combo"
                              id="buy_bo_combo"
                              v-validate="'required|numeric'"
                            />
                          </div>

                          <span class="text-nowrap"
                            >{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span
                          >

                          <div class="col-3">
                            <div class="dropdown-curve-container">
                              <label
                                :class="
                                  offerTypes.buyAndGetCombo.boxOffice
                                    .selectedGetFnbItem &&
                                  offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.hasOwnProperty(
                                    'item_id'
                                  )
                                    ? 'shift-up'
                                    : ''
                                "
                                >{{ $tc("fnbitems") }}</label
                              >
                              <div>
                                <multiselect
                                  v-model="
                                    offerTypes.buyAndGetCombo.boxOffice
                                      .selectedGetFnbItem
                                  "
                                  :options="masterData.fnbItems"
                                  :placeholder="$tc('fnbitems')"
                                  label="item_name"
                                  isSingleId="item_id"
                                  :multiple="false"
                                  track-by="item_id"
                                ></multiselect>
                              </div>
                            </div>
                          </div>

                          <div class="d-flex align-items-center" style="">
                            <b-form-checkbox
                              class="j-checkbox pb-0 ml-1"
                              v-model="
                                offerTypes.buyAndGetCombo.boxOffice
                                  .oc_is_combo_free
                              "
                              unchecked-value="N"
                              value="Y"
                            ></b-form-checkbox>

                            <span class="text-nowrap">{{ $t("free") }}</span>
                          </div>
                          <div
                            v-if="
                              offerTypes.buyAndGetCombo.boxOffice
                                .oc_is_combo_free === 'N'
                            "
                            style="display: flex"
                          >
                            <div class="d-flex align-items-center ml-5">
                              <span class="text-nowrap"
                                >&nbsp;{{ $t("offer") }} {{ $t("value") }}</span
                              >
                              <div class="input-material-sm mx-2">
                                <input
                                  style="text-align: right"
                                  type="text"
                                  name="free_combo_bo_offer_value"
                                  id="free_combo_bo_offer_value"
                                  v-validate="'required|decimal'"
                                  v-model="
                                    offerTypes.buyAndGetCombo.boxOffice
                                      .oc_discount_value
                                  "
                                />
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox
                                class="j-checkbox pb-0 ml-3"
                                v-model="
                                  offerTypes.buyAndGetCombo.boxOffice
                                    .oc_discount_value_is_percentage
                                "
                                unchecked-value="N"
                                value="Y"
                                switch
                              ></b-form-checkbox>
                              {{ $t("isPercentage") }}
                            </div>
                          </div>
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('buy_bo_combo')) ||
                            (offerTypes.buyAndGetCombo.boxOffice
                              .oc_is_combo_free === 'N' &&
                              errors.has('free_combo_bo_offer_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("buy_bo_combo") ||
                            errors.first("free_combo_bo_offer_value")
                          }}</span>
                        </p>
                        <p
                          v-else-if="
                            submitted &&
                            offerTypes.buyAndGetCombo.boxOffice
                              .oc_buy_no_of_ticket != null &&
                            !offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.hasOwnProperty(
                              'item_id'
                            )
                          "
                          class="error_message"
                        >
                          <span>Please select F&B item for get.</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Fixed Price Ticket And FNB-->
              <div
                class="offer-content-wrapper py-0 pl-0"
                v-if="offerTypes.selectedOfferType == 'fixedPriceTicketFnb'"
              >
                <div class="row section-border px-2 py-3 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12">
                    <div class="row mx-0 align-items-center">
                      <div>
                        <span class="text-nowrap">{{ $t("buy") }}</span>
                      </div>
                      <div class="input-material-sm mx-1">
                        <input
                          style="text-align: right"
                          v-model="
                            offerTypes.buyTicketFnbFixedPrice
                              .oc_buy_no_of_ticket
                          "
                          type="text"
                          name="buy_fixed_price_ticket_count"
                          id="buy_fixed_price_ticket_count"
                          v-validate="'required'"
                        />
                      </div>

                      <span class="text-nowrap">{{ $t("tickets") }}</span>

                      <div style="display: flex">
                        <div class="d-flex align-items-center ml-2">
                          <span class="text-nowrap"
                            >{{ $t("atFlatRate") }}&nbsp;</span
                          >
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              type="text"
                              name="fixedPrice_bo_offer_value"
                              id="fixedPrice_bo_offer_value"
                              v-validate="'required'"
                              v-model="
                                offerTypes.buyTicketFnbFixedPrice
                                  .oc_discount_value
                              "
                            />
                          </div>
                          <span class="text-nowrap">{{ $t("Each") }}</span>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          class="j-checkbox pb-0 ml-5"
                          id="combineFixedTicketFnb"
                          name="combineFixedTicketFnb"
                          v-model="
                            offerTypes.buyTicketFnbFixedPrice
                              .oc_is_combo_with_fnb
                          "
                          unchecked-value="N"
                          value="Y"
                        >
                        </b-form-checkbox>
                        <label class="mt-2" for="combineFixedTicketFnb">
                          {{ $t("combinewithfnb") }}</label
                        >
                      </div>

                      <div style="display: flex">
                        <div class="d-flex align-items-center ml-5">
                          <span class="text-nowrap"
                            >{{ "Max Ticket Limit" }}&nbsp;</span
                          >
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              type="text"
                              name="mx_count_ticket"
                              id="mx_count_ticket"
                              v-model="
                                offerTypes.buyTicketFnbFixedPrice
                                  .oc_max_no_of_ticket_per_transaction
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- SHOW ERROR HERE -->
                  </div>
                  <div class="col-lg-12 col-xl-12">
                    <p
                      v-if="
                        (submitted &&
                          errors.has('buy_fixed_price_ticket_count')) ||
                        (submitted && errors.has('fixedPrice_bo_offer_value'))
                      "
                      class="error_message"
                    >
                      <span>{{
                        errors.first("buy_fixed_price_ticket_count") ||
                        errors.first("fixedPrice_bo_offer_value")
                      }}</span>
                    </p>
                  </div>

                  <div
                    class="col-lg-12 col-xl-12 pl-0 mt-3"
                    v-if="
                      offerTypes.buyTicketFnbFixedPrice.oc_is_combo_with_fnb ==
                      'Y'
                    "
                  >
                    <div
                      class="row mx-0 align-items-center mb-3"
                      v-for="(fnbCombo, fnbComboIndex) in offerTypes
                        .buyTicketFnbFixedPrice.fnb_group_data"
                      :key="fnbComboIndex"
                    >
                      <div class="col-md-1">
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div>
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input
                              style="text-align: right"
                              v-model="fnbCombo.oc_buy_no_of_item"
                              type="text"
                              name="buy_fixedprice_item"
                              id="buy_fixedprice_item"
                              v-validate="'required'"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="">
                          <multiselect
                            v-model="fnbCombo.selectedFnbItem"
                            @select="
                              selectFnbItemFixedOffer(
                                $event,
                                fnbComboIndex,
                                'Add'
                              )
                            "
                            @remove="
                              selectFnbItemFixedOffer(
                                $event,
                                fnbComboIndex,
                                'Remove'
                              )
                            "
                            :options="masterData.fnbItems"
                            :placeholder="$tc('fnbitems')"
                            label="item_name"
                            isSingleId="item_id"
                            :multiple="false"
                            track-by="item_id"
                          ></multiselect>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div style="display: flex">
                          <div class="d-flex align-items-center">
                            <span class="text-nowrap"
                              >{{ $t("atFlatRate") }}&nbsp;</span
                            >
                            <div class="input-material-sm mx-2">
                              <input
                                style="text-align: right"
                                type="text"
                                name="fixed_fnb_bo_offer_value"
                                id="fixed_fnb_bo_offer_value"
                                v-validate="'required'"
                                v-model="fnbCombo.oc_fnb_at_price"
                              />
                            </div>
                            <span class="text-nowrap">{{ $t("Each") }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div
                          class="d-flex justify-content-center align-items-center"
                        >
                          <button
                            class="btn-transparent"
                            @click="addFnbCriteria()"
                            v-if="fnbComboIndex == 0"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="29"
                              width="29"
                            />
                          </button>
                          <button
                            v-if="fnbComboIndex !== 0"
                            class="btn-transparent"
                            @click="removeFnbCriteria(fnbComboIndex)"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="29"
                              width="29"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- SHOW ERROR HERE -->
                  </div>
                </div>
              </div>

              <!--Buy 1 get Off on Another Ticket-->
              <div
                class="offer-content-wrapper py-0 pl-0"
                v-if="offerTypes.selectedOfferType == 'buyAndgetOffOnAnother'"
              >
                <div class="row section-border p-2 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12">
                    <div
                      class="row d-flex mx-0 align-items-center"
                      style="gap: 35px"
                    >
                      <div class="align-self-center mb-2">
                        <div class="d-flex align-items-center">
                          {{ $t("buy") }}
                          <div class="input-material-sm mx-1">
                            <input
                              style="text-align: right"
                              name="discount_buy_value"
                              id="discount_buy_value"
                              v-validate="'required|numeric'"
                              type="text"
                              v-model="
                                offerTypes.buyAndgetOffOnAnother
                                  .oc_buy_no_of_ticket
                              "
                            />
                          </div>
                          {{ $t("buyAndgetOffOnAnother_des") }}
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              type="text"
                              name="discount_get_value"
                              id="discount_get_value"
                              v-validate="'required|numeric'"
                              v-model="
                                offerTypes.buyAndgetOffOnAnother
                                  .oc_discount_value
                              "
                            />
                          </div>
                          <span
                            v-if="
                              offerTypes.buyAndgetOffOnAnother
                                .oc_discount_value_is_percentage == 'Y'
                            "
                            >{{ "%" }}</span
                          >
                          <span v-else>{{ "Flat" }}</span>
                          &nbsp;
                          {{ $t("buyAndgetOffOnAnother_des2") }}
                        </div>
                        <p
                          v-if="
                            (submitted && errors.has('discount_buy_value')) ||
                            (submitted && errors.has('discount_get_value'))
                          "
                          class="error_message"
                        >
                          <span>{{
                            errors.first("discount_buy_value") ||
                            errors.first("discount_get_value")
                          }}</span>
                        </p>
                      </div>
                      <div class="align-self-center mb-2">
                        <div class="d-flex align-items-center">
                          <b-form-checkbox
                            class="j-checkbox pb-0"
                            v-model="
                              offerTypes.buyAndgetOffOnAnother
                                .oc_discount_value_is_percentage
                            "
                            unchecked-value="N"
                            value="Y"
                          ></b-form-checkbox>
                          {{ $t("Percentage") }}
                        </div>
                      </div>

                      <div class="align-self-center mb-lg-2 mb-xl-2">
                        <div class="d-flex align-items-center">
                          {{ "Max Ticket Limit" }}
                          <div class="input-material-sm mx-2">
                            <input
                              style="text-align: right"
                              type="text"
                              name="max_discount_per_trans"
                              id="max_discount_per_trans"
                              v-model="
                                offerTypes.buyAndgetOffOnAnother
                                  .oc_max_no_of_ticket_per_transaction
                              "
                            />
                          </div>
                        </div>
                      </div>

                      <div class="d-flex align-self-center mb-lg-2 mb-xl-2">
                        <div class="mx-2 mb-2">
                          <b-form-radio
                            value="N"
                            class="j-radio"
                            v-model="
                              offerTypes.buyAndgetOffOnAnother
                                .oc_offer_on_higher_amount
                            "
                          >
                            <div>{{ "Lower Price" }}</div>
                          </b-form-radio>
                        </div>
                        <div class="mx-2 mb-2">
                          <b-form-radio
                            value="Y"
                            class="j-radio"
                            v-model="
                              offerTypes.buyAndgetOffOnAnother
                                .oc_offer_on_higher_amount
                            "
                          >
                            <div>{{ "Higher Price" }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Free Tickets -->
              <div
                class="offer-content-wrapper section-border mt-3 p-2"
                v-if="offerTypes.selectedOfferType == 'freeTickets'"
              >
                <div class="row p-1">
                  <div class="col-3">
                    <div class="input-material">
                      <input
                        v-model="offerTypes.freeTickets.freeTicketCount"
                        placeholder=""
                        type="number"
                      />
                      <label>Free Tickets</label>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <b-form-checkbox
                      @input="handleFreeMinTicket($event)"
                      unchecked-value="N"
                      value="Y"
                      v-model="offerTypes.freeTickets.isMinFreeeTicketCount"
                      class="j-checkbox pb-0"
                    ></b-form-checkbox>
                    <div class="ml-2">Is Min ticket limit</div>
                  </div>
                  <div class="col-3">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        @input="handleFreeMaxTicket($event)"
                        unchecked-value="N"
                        value="Y"
                        class="j-checkbox pb-0"
                      ></b-form-checkbox>
                      <div class="ml-2">Is max ticket limit</div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="input-material">
                      <input
                        v-model="offerTypes.freeTickets.maxDiscountAmount"
                        placeholder=""
                        type="number"
                      />
                      <label>Max. Ticket Amount</label>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="offer-content-wrapper section-border mt-3 p-3"
                v-if="offerTypes.selectedOfferType == 'fnbItemDiscounts'"
              >
                <div class="row p-0 m-0">
                  <div class="col-7 p-0">
                    <table
                      class="swc-report-table"
                      border="1"
                      style="table-layout: auto; background: white; zoom: 0.9"
                    >
                      <thead>
                        <tr class="bg-lightprimary">
                          <th class="bg-lightprimary p-1" style="width: 900px">
                            Fnb Items<span class="required_star">*</span>
                          </th>
                          <th class="bg-lightprimary p-1" style="width: 150px">
                            Discounts (%)<span class="required_star">*</span>
                          </th>
                          <th style="width: 10px"></th>
                        </tr>
                      </thead>
                      <tbody
                        v-if="
                          offerTypes.fnbItemDiscounts &&
                          offerTypes.fnbItemDiscounts.length > 0
                        "
                      >
                        <template
                          v-for="(
                            fnbItemObj, fnbItemIndexObj
                          ) in offerTypes.fnbItemDiscounts"
                        >
                          <tr :key="fnbItemIndexObj">
                            <td class="text-left p-0 manual_bill_item">
                              <div class="dropdown-curve-container">
                                <label
                                  v-if="
                                    !fnbItemObj.selectedFnbItem ||
                                    !fnbItemObj.selectedFnbItem.length
                                  "
                                  :class="
                                    fnbItemObj.selectedFnbItem &&
                                    fnbItemObj.selectedFnbItem.length
                                      ? 'shift-up'
                                      : 'font-weight-bold'
                                  "
                                  >{{ $tc("fnbitems") }}</label
                                >

                                <div>
                                  <multiselect
                                    :value="fnbItemObj.selectedFnbItem"
                                    :options="fnbItemObj.fnbItemList"
                                    placeholder=""
                                    group-values="fnbItemsData"
                                    group-label="fc_name"
                                    :group-select="true"
                                    label="item_name"
                                    :searchable="true"
                                    isSingleId="item_id"
                                    :multiple="true"
                                    track-by="item_id"
                                    :closeOnSelect="false"
                                    :limit="2"
                                    :limit-text="(count) => `& +${count} More`"
                                    @select="
                                      updateFnbList(
                                        fnbItemIndexObj,
                                        $event,
                                        'add'
                                      )
                                    "
                                    @remove="
                                      updateFnbList(
                                        fnbItemIndexObj,
                                        $event,
                                        'remove'
                                      )
                                    "
                                  ></multiselect>
                                </div>
                              </div>
                            </td>
                            <td class="text-left p-0 manual_bill_item">
                              <div class="manual_bill_input">
                                <input
                                  v-model="fnbItemObj.fnb_item_offer"
                                  placeholder="Discount"
                                  type="number"
                                  class="text-right"
                                />
                              </div>
                            </td>
                            <td>
                              <button
                                @click.prevent.stop="
                                  removeFnbItemDiscountRow(fnbItemIndexObj)
                                "
                                class="btn-transparent"
                              >
                                <img
                                  src="@/assets/img/icons/minus.svg"
                                  height="20"
                                  width="20"
                                />
                              </button>
                            </td>
                          </tr>
                        </template>
                        <tr class="">
                          <td colspan="12">
                            <div
                              class="row d-flex align-items-center justify-content-center position-relative"
                            >
                              <button
                                @click.prevent.stop="addFnbItemDiscountRow()"
                                class="btn-transparent"
                              >
                                <img
                                  src="@/assets/img/icons/plus.svg"
                                  height="20"
                                  width="20"
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody
                        v-if="
                          !offerTypes.fnbItemDiscounts ||
                          !offerTypes.fnbItemDiscounts.length
                        "
                      >
                        <tr class="">
                          <td colspan="12">
                            <div
                              class="row d-flex align-items-center justify-content-center position-relative"
                            >
                              <button
                                @click.prevent.stop="addFnbItemDiscountRow()"
                                class="btn-transparent"
                              >
                                <img
                                  src="@/assets/img/icons/plus.svg"
                                  height="20"
                                  width="20"
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="offer-content-wrapper section-border mt-3 p-2"
                v-if="offerTypes.selectedOfferType == 'onlyFnbFixed'"
              >
                <div class="row section-border px-2 py-3 mx-1 mt-3">
                  <!-- <div class="col-md-1">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div>
                        <span class="text-nowrap">{{ $t("buy") }}</span>
                      </div>
                      <div class="input-material-sm mx-1">
                        <input
                          style="text-align: right"
                          v-model="offerTypes.onlyFnbFixed.oc_buy_item_count"
                          type="text"
                          name="buy_onlyFnbFixed_item"
                          id="buy_onlyFnbFixed_item"
                          v-validate="'required'"
                        />
                      </div>
                    </div>
                  </div> -->

                  <div class="col-md-3">
                    <div class="">
                      <multiselect
                        v-model="offerTypes.onlyFnbFixed.oc_buy_item_code"
                        :options="masterData.fnbItems"
                        :placeholder="$tc('fnbitems')"
                        label="item_name"
                        isSingleId="item_id"
                        :multiple="false"
                        track-by="item_id"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div
                      class="d-flex align-items-center justify-content-evenly"
                    >
                      <div>
                        <span class="text-nowrap">Discount Price</span>
                      </div>
                      <div class="input-material-sm mx-1">
                        <input
                          style="text-align: right"
                          v-model="offerTypes.onlyFnbFixed.oc_discount_value"
                          type="text"
                          name="discount_onlyFnbFixed_item"
                          id="discount_onlyFnbFixed_item"
                          v-validate="'required'"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div
                      class="d-flex align-items-center justify-content-evenly"
                    >
                      <div>
                        <span class="text-nowrap">Max Discount Quantity</span>
                      </div>
                      <div class="input-material-sm mx-1">
                        <input
                          style="text-align: right"
                          v-model="
                            offerTypes.onlyFnbFixed
                              .oc_max_no_of_ticket_per_transaction
                          "
                          type="text"
                          name="discount_qty_onlyFnbFixed_item"
                          id="discount_qty_onlyFnbFixed_item"
                          v-validate="'required'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- redemption outlet -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Redemption Outlet</h5>

          <div class="row align-items-center mt-3">
            <div class="col-12 col-md-12 col-lg-3 col-xl-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    redemptionOutlet.selectedUsers.length
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                >
                  {{ $tc("Sales Channel") }}
                </label>
                <div>
                  <multiselect
                    v-model="redemptionOutlet.selectedUsers"
                    :options="masterData.userList"
                    :close-on-select="false"
                    placeholder=""
                    label="user_name"
                    isSingleId="user_id"
                    :multiple="true"
                    track-by="user_id"
                  ></multiselect>
                </div>
              </div>
            </div>

            <!-- <div class="col-lg-2 col-xl-2 align-self-center">
                <div class="d-flex align-items-center">
                  <b-form-checkbox :disabled="offerTypes.is_employee_offer == 'Y'"
                    v-model="redemptionOutlet.offer_redeem_at_online" unchecked-value="N" value="Y"
                    class="j-checkbox pb-0"></b-form-checkbox>
                  <div class="ml-2">{{ $t("canavailonline") }}</div>
                </div>
              </div> -->

            <div
              class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center my-2"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :disabled="
                    ['fnbItemDiscounts'].includes(offerTypes.selectedOfferType)
                  "
                  v-model="redemptionOutlet.offer_redeem_at_boxoffice"
                  unchecked-value="N"
                  value="Y"
                  class="j-checkbox pb-0"
                ></b-form-checkbox>
                <div class="ml-2">{{ $t("availatboxoffice") }}</div>
              </div>
            </div>

            <div
              class="col-12 col-md-6 col-lg-3 col-xl-3 align-self-center my-2"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :disabled="
                    [
                      'buyAndGetFreeTickets',
                      'fixedPriceTicketFnb',
                      'buyAndgetOffOnAnother',
                      'fnbItemDiscounts',
                    ].includes(offerTypes.selectedOfferType)
                  "
                  v-model="redemptionOutlet.offer_redeem_at_concession"
                  unchecked-value="N"
                  value="Y"
                  class="j-checkbox pb-0"
                ></b-form-checkbox>
                <div class="ml-2 d-flex">
                  {{ $t("availatconcession") }}<br />
                  <span class="text-muted fs-12">
                    {{
                      [
                        "buyAndGetFreeTickets",
                        "fixedPriceTicketFnb",
                        "buyAndgetOffOnAnother",
                      ].includes(offerTypes.selectedOfferType)
                        ? "(Not Applicable)"
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>

            <div v-if="isEpix" class="col-12 col-md-12 col-lg-4 my-2">
              <div class="d-flex align-items-center">
                <b-form-radio
                  value="gross"
                  class="j-radio"
                  v-model="redemptionOutlet.offer_applicable_on"
                  @change="handleRadioChange($event)"
                >
                  <div>
                    <span>{{ $tc("ApplicableOnGrossAmount") }}</span>
                  </div>
                </b-form-radio>
                <strong class="mx-3">OR</strong>

                <b-form-radio
                  value="net"
                  class="j-radio"
                  v-model="redemptionOutlet.offer_applicable_on"
                  @change="handleRadioChange($event)"
                >
                  <div>
                    <span>{{ $tc("ApplicableOnNetAmount") }}</span>
                  </div>
                </b-form-radio>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!---dstributor report sectiion-->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 px-2 mb-2">
          <h5 class="heading">Distributor Reporting Values</h5>

          <div
            class="row greyBackground my-2 px-2 py-2 mx-2"
            v-for="(
              settingsObj, settingsIndex
            ) in distributorSection.distributorData"
            :key="settingsIndex"
          >
            <div class="col-11">
              <div class="row bg-white">
                <div class="col-12 col-lg-3 my-2">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        settingsObj.selectedCinema &&
                        settingsObj.selectedCinema.cine_name
                          ? 'shift-up'
                          : 'font-weight-bold'
                      "
                      >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
                    >
                    <multiselect
                      v-model="settingsObj.selectedCinema"
                      :options="masterData.cinemasList"
                      open-direction="bottom"
                      :placeholder="$tc('Cinemas')"
                      label="cine_name"
                      track-by="cine_id"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="col-12 col-lg-3 my-2">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        settingsObj.selectedSeatTypes.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                      "
                      >{{ $t("select") }} Seat Types</label
                    >
                    <multiselect
                      v-model="settingsObj.selectedSeatTypes"
                      :options="masterData.seatGroups"
                      open-direction="bottom"
                      :close-on-select="false"
                      placeholder="Seat Groups"
                      label="sstg_name"
                      track-by="sstg_id"
                      :multiple="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="col-12 col-lg-3 my-2">
                  <div class="dropdown-curve-container">
                    <label
                      :class="
                        settingsObj.selectedTickets.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                      "
                      >{{ $t("select") }} Ticket Types</label
                    >
                    <multiselect
                      v-model="settingsObj.selectedTickets"
                      :options="masterData.ticketTypesData"
                      open-direction="bottom"
                      :close-on-select="false"
                      placeholder="Tickets"
                      label="tt_name"
                      track-by="tt_id"
                      :multiple="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <div class="col-2 col-lg-3 d-flex align-items-center">
                  <div class="input-material">
                    <input
                      v-model="settingsObj.pvds_dist_value"
                      placeholder=""
                      type="number"
                    />
                    <label>Dist.Value</label>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center"
            >
              <button
                class="btn-transparent"
                @click="handleDistributorRowAction('remove', settingsIndex)"
              >
                <img
                  src="@/assets/img/icons/minus.svg"
                  height="30"
                  width="30"
                />
              </button>
            </div>
          </div>
          <div class="row justify-content-center">
            <button
              class="btn-transparent mb-3"
              @click="handleDistributorRowAction('add')"
            >
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
          </div>
        </div>
      </section>

      <div
        class="row d-flex justify-content-center aling-items-center pr-2 py-2"
      >
        <!-- <div
          class="icon-save-btn blue-icon mx-1 btn float-right"
          :title="'Save'"
          :disabled="btn_disable"
          @click="OnFinalSubmit"
        ></div> -->
        <button @click="OnFinalSubmit" class="btn-blue">Save</button>
      </div>
    </div>
    <ImageGallery
      v-bind:propImageName="'Offer Image'"
      v-bind:openModal="offerContent.showModal"
      v-bind:set_height="offerContent.set_height"
      v-bind:set_width="offerContent.set_width"
      :showPercentageLoader="true"
      :cropSizeResizable="signageImageData.cropSizeEnable"
      :img_desc="'Offer Image'"
      :resetImgData="false"
      :category="'Offer Image'"
    ></ImageGallery>
  </div>
</template>

<script>
import { generateRandomCode } from "@/helper/collection";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import moment from "moment";
import PosFnBService from "@/services/Pos_Fnb_Service";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { VueEditor } from "vue2-editor";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
import _ from "lodash";

let Start_Date = moment(
  `${moment().subtract(1, "days").format("YYYY-MM-DD")} 24:00:00`
).format();
let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

let startTime = "06.00";
export default {
  components: { DatePicker, VueTimepicker, VueEditor, ImageGallery },
  data() {
    return {
      offerSelected: true,
      voucherSelected: false,
      titleName: "Offer",
      submitted: false,
      //Collapse
      sectionCollapse: {
        offer: true,
        offer_content: false,
        vouher: false,
        cinema_configuration: false,
        movie_configuration: false,
        day_configuration: false,
        split_configuration: false,
        other_setting: false,
        offer_type: false,
        outlet: false,
        vouher_config: false,
        distributor_reporting: false,
      },
      selectedOfferGroupType: {},

      offer: {
        os_is_active: "Y",
        offer_title: "",
        offer_code: generateRandomCode(8),
        offer_start_date_time: Start_Date,
        offer_end_date_time: End_date,
        offer_start_time: "06:00",
        offer_end_time: "05:59",
        offer_group_type_id: 1,
        offer_description_text: "",
        is_offer_auth_required: "N",
        visible_on_web: "N",
        is_redemption: "N",
        is_package_offer: "N",
        report_offer: "N",
        customers_only: "N",
        auto_apply: "N",
        is_dynamic_voucher: "N",
        selectedOfferGroupType: {},
      },

      offerContent: {
        offerContentArray: [],
        imageType: null,
        pg_promo_code: [],
        activeIndex: 0,
        notempty: [false, false, false, false, false, false],
        uploadImageType: "",
        bannerUpload: false,
        set_height: null,
        set_width: null,
        uploadIndex: null,
        showModal: false,
        isEdit: true,
        isEditHtml: false,
        banner_image_height: 690,
        banner_image_width: 2400,
        poster_image_height: 400,
        poster_image_width: 400,
      },

      cinemaSettingsSection: {
        isCinemaSettingsApplicable: "N",
        allCinemaRowNotApplicableStatus: "Y",
        cinemaSettings: [],
        rejectedCinemaIds: [],
      },
      distributorSection: {
        distributorData: [],
      },
      check: [],
      offerCinemaConfiguration: {},
      offerMovieConfiguration: {
        os_is_foreign_movie_applicable: "N",
        os_movie_mf_id: "",
        os_is_movie_applicable: "Y",
        selectedMovieFormats: [],
        selectedParticaularMovies: [],
        movies_applicable_status: "movies_applicable",
        start_show_time: "06:00",
        end_show_time: "05:59",
        os_time_limit_start: null,
        os_time_limit_end: null,
      },

      offerDaysConfiguration: {
        offer_applicable_on_all_day: "Y",
        TrueFalseCount: null,
        weekDays: {
          selectAll: "Y",
          sunday: "Y",
          monday: "Y",
          tuesday: "Y",
          wednesday: "Y",
          thursday: "Y",
          friday: "Y",
          saturday: "Y",
        },
      },
      offerSplitConfiguration: {
        client_share_value: null,
        client_share_is_percentage: "Y",
        offer_dist_share_threshold: null,
        selectedClient: {},
      },
      offerSettingConfiguration: {
        is_bank_offer: "N",
        bankDetails: {
          selectedBank: "",
          selectedCard: [],
          bank_id: null,
          card_type_ids: null,
        },
        report_full_amount: "N",
        report_full_amount_special_rc: "N",
        has_o_reporting_percent: "N",
        o_reporting_percent: null,
        clientShareSettings: {
          client: null,
          client_share_value: 0,
          is_share_percentage: "Y",
          is_prepaid_voucher: "N",
        },
      },
      offerTypes: {
        selectedOfferType: "fixedDiscount",
        is_employee_offer: "N",
        freeTickets: {
          freeTicketCount: null,
          maxFreeeTicketCount: null,
          maxDiscountAmount: null,
          minFreeeTicketCount: null,
        },
        discountLists: [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
            canCombineOtherOffers: "N",
            selectedCombinedOffer: null,
          },
        ],
        fixedDiscount: {
          oc_buy_no_of_ticket: "",
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
          oc_min_ticket_price: 0,
          oc_min_fnb_price: 0,
          min_amount_channel_wise: "N",
          canCombineOtherOffers: "N",
          selectedCombinedOffer: null,
        },
        buyAndGetFreeTickets: {
          oc_buy_no_of_ticket: null,
          oc_get_free_ticket: null,
          oc_min_ticket_price: null,
          oc_max_no_of_ticket_per_transaction: null,
          oc_combine_with_other_offers: "N",
        },
        discount: {
          oc_buy_no_of_ticket: "",
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
        },
        loyalityProgramOffer: {
          oc_buy_no_of_ticket: "",
          oc_discount_value: "",
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
        },
        buyAndGetCombo: {
          offerApplicableAt: "boxOffice",
          boxOffice: {
            oc_buy_no_of_ticket: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            selectedGetFnbItem: {},
          },
          F_And_B: {
            oc_buy_item_count: null,
            oc_get_item_count: null,
            oc_buy_item_id: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value_is_percentage: "N",
            oc_discount_value: null,
            selectedBuyFnbItem: {},
            selectedGetFnbItem: {},
          },
        },
        buyTicketFnbFixedPrice: {
          oc_buy_no_of_ticket: null,
          oc_ticket_at_price: null,
          oc_min_ticket_price: null,
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_no_of_ticket_per_transaction: null,
          oc_is_combo_with_fnb: "N",
          fnb_group_data: [
            {
              oc_buy_no_of_item: null,
              oc_buy_item_id: null,
              oc_buy_item_code: null,
              selectedFnbItem: {},
              oc_fnb_at_price: null,
            },
          ],
        },
        buyAndgetOffOnAnother: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: "",
          oc_discount_value_is_percentage: "Y",
          oc_offer_on_higher_amount: "N",
          oc_max_no_of_ticket_per_transaction: null,
        },

        fnbItemDiscounts: [
          {
            fnb_item_code: "",
            selectedFnbItem: [],
            fnb_item_offer: null,
            fnbItemList: [],
            error: false,
          },
        ],

        onlyFnbFixed: {
          oc_buy_item_id: null,
          oc_buy_item_code: null,
          // oc_buy_item_count: null,
          oc_discount_value: null,
          oc_max_no_of_ticket_per_transaction: null,
        },
      },
      redemptionOutlet: {
        offer_redeem_at_online: "Y",
        offer_redeem_at_boxoffice: "Y",
        offer_redeem_at_concession: "N",
        offer_applicable_on: "gross",
        offer_applicable_on_gross_amount: "Y",
        offer_applicable_on_net_amount: "N",
        selectedUsers: [],
      },
      signageImageData: {
        signageContainer: [
          {
            width: 1920,
            height: 1080,
            imageUrl: "",
          },
          {
            width: 1920,
            height: 1080,
            imageUrl: "",
          },
        ],
        _downloadImagePath: null,
        cropSizeEnable: false,
      },
      voucherSettting: {
        is_generate_multiple: false,
        voucher_prefix: "",
        is_random: true,
        code_length: 8,
        sequence_start: null,
        total_vouchers: null,
      },
      vouchersConfigation: {
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
      },
      masterData: {
        offerGroupTypes: [],
        movieFormats: [],
        movieList: [],
        cinemasList: [],
        clientList: [],
        activeBankList: [],
        activeBankCardList: [],
        fnbItems: [],
        ContentLanguages: [],
        userList: [],
      },
      fnbItemsForFnbDiscount: [],
      originalFnbItemForFnbDiscount: [],
      rejectedFnbItemCode: [],
      custom_errors: {
        only_cinema_error: "",
        weekday_errors: "",
        voucher_start_date_error: "",
      },
      btn_disable: false,
    };
  },

  watch: {
    finalImagePath(newVal) {
      console.log("newValue=>", newVal);
      console.log("check for type=>", this.offerContent);

      if (this.offerContent.imageType == 1) {
        console.log("newValue=>1", newVal);
        this.offerContent.offerContentArray[
          this.offerContent.activeIndex
        ].offer_banner_image = newVal;
      }
      if (this.offerContent.imageType == 3) {
        console.log("newValue=>3", newVal);
        this.signageImageData.signageContainer[
          this.offerContent.uploadIndex
        ].imageUrl = newVal;
      }
      if (this.offerContent.imageType == 2) {
        console.log("newValue=>2", newVal);
        this.offerContent.offerContentArray[
          this.offerContent.activeIndex
        ].offer_poster_image = newVal;
      }
      this.offerContent.uploadImageType = "";
      this.$forceUpdate();
    },
    "sectionCollapse.distributor_reporting": function (newValue) {
      if (newValue === true && this.masterData.seatGroups.length === 0) {
        this.getSeatGroups();
        this.getTicketType();
      }
      if (
        newValue === true &&
        this.distributorSection.distributorData.length === 0
      ) {
        console.log("first row push");
        this.handleDistributorRowAction("add");
      }
    },
  },

  computed: {
    ...mapGetters(["finalImagePath"]),
    showGrossNetButton() {
      return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
    },
    showForeignMovieSection() {
      return CLIENT_NAMES_OBJ.showForeignMovieSection.includes(
        String(this.CLIENT_SETUP_NAME)
      );
    },
    selectedUsersLength() {
      return this.redemptionOutlet.selectedUsers
        ? this.redemptionOutlet.selectedUsers.length
        : 0;
    },
    isEpix() {
      return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
    },
    isReportingFeeClient() {
      return CLIENT_NAMES_OBJ.reportingFeeClient.includes(
        String(this.CLIENT_SETUP_NAME)
      );
    },
  },

  beforeMount() {
    Promise.all([
      this.getMovieFormats(),
      this.getCinemasList(),
      this.getActiveMovies(),
      this.getClientList(),
      this.getBankList(),
      this.getFnBItems(),
      this.getOfferGroupType(),
      this.getUserList(),
      // this.getContentLanguage(),
      this.getContentLangauge(),
      this.getSeatGroups(),
      this.getTicketType(),
      this.getFnBItemsForFnbDiscountOfferType(),
    ]);
  },
  methods: {
    handleFreeMaxTicket(event) {
      if (!this.offerTypes.freeTickets.freeTicketCount)
        return this.$toasted.show("Enter number of free tickets first");
      if (event == "Y") {
        this.offerTypes.freeTickets.maxFreeeTicketCount =
          this.offerTypes.freeTickets.freeTicketCount;
      } else {
        this.offerTypes.freeTickets.maxFreeeTicketCount = null;
      }
    },
    handleFreeMinTicket(event) {
      if (!this.offerTypes.freeTickets.freeTicketCount)
        return this.$toasted.show("Enter number of free tickets first");
      if (event == "Y") {
        this.offerTypes.freeTickets.minFreeeTicketCount =
          this.offerTypes.freeTickets.freeTicketCount;
      } else {
        this.offerTypes.freeTickets.minFreeeTicketCount = null;
      }
    },
    handleFreeMaxTicketAmount(event) {
      console.log("test");
      if (!this.offerTypes.freeTickets.freeTicketCount)
        return this.$toasted.show("Enter number of free tickets first");
      if (event == "Y") {
        this.offerTypes.freeTickets.maxDiscountAmount =
          this.offerTypes.freeTickets.maxDiscountAmount;
      } else {
        this.offerTypes.freeTickets.maxDiscountAmount = null;
      }
    },
    handleApplicableCinemaSettings(event) {
      if (event == "Y") {
        this.cinemaSettingsSection.cinemaSettings.push({
          selectedCinema: [],
          allowedCinemaList: this.masterData.cinemasList,
          allowedScreenList: [],
          cinemaScreens: [],
          selectedScreens: [],
          selectedSeatTypes: [],
          selectedTickets: [],
          is_settings_applicable: "Y",
        });
      } else {
        this.cinemaSettingsSection.cinemaSettings = [];
      }
    },
    handleScreenSeatData(index, type, event) {
      if (
        type == "applicableKey" &&
        event == "N" &&
        this.cinemaSettingsSection.cinemaSettings[index]["selectedScreens"]
          .length > 0
      ) {
        this.cinemaSettingsSection.cinemaSettings[index]["selectedScreens"] =
          [];
      }
      if (
        type == "applicableKey" &&
        event == "N" &&
        this.cinemaSettingsSection.cinemaSettings[index]["selectedSeatTypes"]
          .length > 0
      ) {
        this.cinemaSettingsSection.cinemaSettings[index]["selectedSeatTypes"] =
          [];
      }
    },
    async handleCinemaSettings(type, index = null) {
      if (type === "add") {
        let data = await this.getCinemaList();
        if (!data.length) {
          return this.$toasted.show("cinemas is not availble for next row");
        }
        this.cinemaSettingsSection.cinemaSettings.push({
          selectedCinema: [],
          cinemaScreens: [],
          allowedCinemaList: data,
          allowedScreenList: [],
          selectedScreens: [],
          selectedSeatTypes: [],
          selectedTickets: [],
          is_settings_applicable:
            this.cinemaSettingsSection.allCinemaRowNotApplicableStatus,
        });
      } else {
        let removedRow = this.cinemaSettingsSection.cinemaSettings.splice(
          index,
          1
        );
        console.log("remvoedrow=>", removedRow.selectedCinema);

        if (removedRow[0].selectedCinema.length) {
          removedRow[0].selectedCinema.forEach((cinema) => {
            if (
              this.cinemaSettingsSection.rejectedCinemaIds.includes(
                cinema.cine_id
              )
            ) {
              let idIndex =
                this.cinemaSettingsSection.rejectedCinemaIds.indexOf(
                  cinema.cine_id
                );
              if (idIndex >= 0) {
                this.cinemaSettingsSection.rejectedCinemaIds.splice(idIndex, 1);
              }
            }
          });
        }
      }
    },
    handleCinemaScreenChange(index, event) {
      if (event.length > 0) {
        if (event[event.length - 1].screen_id === "all") {
          this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens =
            this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens.map(
              (screens) => ({
                ...screens,
                $isDisabled: true,
              })
            );
          console.log("1");
        } else {
          this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens =
            this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens.map(
              (screens) => ({
                ...screens,
                $isDisabled: false,
              })
            );
          console.log("2");
        }
      } else {
        this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens =
          this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens.map(
            (screens) => ({
              ...screens,
              $isDisabled: false,
            })
          );
        console.log("3");
      }

      if (event.length > 0) {
        if (event[event.length - 1].sstg_id === "all") {
          this.masterData.seatGroups = this.masterData.seatGroups.map(
            (screens) => ({ ...screens, $isDisabled: true })
          );
          console.log("1");
        } else {
          this.masterData.seatGroups = this.masterData.seatGroups.map(
            (screens) => ({ ...screens, $isDisabled: false })
          );
          console.log("2");
        }
      } else {
        this.masterData.seatGroups = this.masterData.seatGroups.map(
          (screens) => ({ ...screens, $isDisabled: false })
        );
        console.log("3");
      }

      if (event.length > 0) {
        if (event[event.length - 1].tt_id === "all") {
          this.masterData.ticketTypesData = this.masterData.ticketTypesData.map(
            (screens) => ({
              ...screens,
              $isDisabled: true,
            })
          );
          console.log("1");
        } else {
          this.masterData.ticketTypesData = this.masterData.ticketTypesData.map(
            (screens) => ({
              ...screens,
              $isDisabled: false,
            })
          );
          console.log("2");
        }
      } else {
        this.masterData.ticketTypesData = this.masterData.ticketTypesData.map(
          (screens) => ({ ...screens, $isDisabled: false })
        );
        console.log("3");
      }
    },
    async getSeatGroups() {
      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_screen_seat_type_group",
          sstg_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.seatGroups = [...data.Records];
          loader.hide();
        } else {
          // Show Errors
          console.log("show error:", data.message);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getTicketType() {
      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_ticket_type",
          tt_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.ticketTypesData = [...data.Records];
          loader.hide();
        } else {
          // Show Errors
          console.log("show error:", data.message);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    toggleSelection(selectedOption) {
      if (selectedOption === "offer") {
        this.titleName = "Offer";
        this.voucherSelected = false; // Deselect voucher if offer is selected
      } else if (selectedOption === "voucher") {
        this.titleName = "Voucher";
        this.offerSelected = false; // Deselect offer if voucher is selected
      }
    },
    handleSequenceClick: function (event) {
      this.voucherSettting.is_random = !this.voucherSettting.is_random;
      this.voucherSettting.is_sequence = !!this.voucherSettting.is_random;
    },
    async getOfferGroupType() {
      try {
        let loader = this.$loading.show();
        const response = await MarketingService.GetAllOfferGroupType({
          status: "Active",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.offerGroupTypes = data.Records;
          loader.hide();
        } else {
          console.log("Error:", data.message);
          this.$toasted.show(data.message);
          loader.hide();
        }
      } catch (err) {
        console.log("Error:", err);
      }
    },
    async getMovieFormats() {
      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.movieFormats = data.Records;
          loader.hide();
        } else {
          // Show Errors
          console.log("show error:", data.message);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    handleMovieApplicableChange(selected) {
      this.offerMovieConfiguration.movies_applicable_status = selected;
      if (selected === "movies_applicable") {
        this.offerMovieConfiguration.os_is_movie_applicable = "Y";
      } else if (selected === "movies_not_applicable") {
        this.offerMovieConfiguration.os_is_movie_applicable = "N";
      }
    },
    handleRadioChange(selected) {
      if (selected === "gross") {
        this.redemptionOutlet.offer_applicable_on_gross_amount = "Y";
        this.redemptionOutlet.offer_applicable_on_net_amount = "N";
      } else if (selected === "net") {
        this.redemptionOutlet.offer_applicable_on_gross_amount = "N";
        this.redemptionOutlet.offer_applicable_on_net_amount = "Y";
      }
    },
    async getActiveMovies() {
      this.masterData.movieList = [];
      try {
        let loader = this.$loading.show();
        const response = await MovieService.GetActiveMoviesWithFormat({
          movieversions: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.movieList = data.Records;
          loader.hide();
        } else {
          this.$toasted.show(data.message || this.AdminError);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },

    onChangeWeekdays: function (event, keyname) {
      this.offerDaysConfiguration.TrueFalseCount = 0;
      const weekDays = this.offerDaysConfiguration.weekDays;
      if (keyname === "selectAll") {
        const newValue = event === "Y" ? "Y" : "N";
        Object.keys(weekDays).forEach((day) => {
          weekDays[day] = newValue;
        });
        this.offerDaysConfiguration.offer_applicable_on_all_day = newValue;
      } else {
        weekDays[keyname] = event;
        if (event === "N" && weekDays["selectAll"] === "Y") {
          weekDays["selectAll"] = "N";
          this.offerDaysConfiguration.offer_applicable_on_all_day = "N";
        } else {
          const allDaysSelected = Object.keys(weekDays).every((day) => {
            return day === "selectAll" || weekDays[day] === "Y";
          });

          weekDays["selectAll"] = allDaysSelected ? "Y" : "N";
          this.offerDaysConfiguration.offer_applicable_on_all_day =
            allDaysSelected ? "Y" : "N";
        }
      }
      Object.keys(weekDays).map((x) => {
        if (x != "selectAll") {
          if (weekDays[x] === "N") {
            this.offerDaysConfiguration.TrueFalseCount++;
          }
        }
      });
    },

    async getClientList() {
      try {
        let loader = this.$loading.show();
        const response = await ClientService.GetAllClients({});
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.clientList = data.Records;
          loader.hide();
        } else {
          this.$toasted.show(data.message);
          loader.hide();
        }
      } catch (error) {
        this.$toasted.show(error);
      }
    },
    handleMaxDiscount() {
      this.offerTypes.discount.oc_max_discount_amount =
        this.offerTypes.discount.oc_discount_value;
    },
    onSelectEmployeeDiscount(event) {
      this.offerSettingConfiguration.selectedOfferType = "fixedDiscount";
    },
    onSelectBankOffer(event) {
      this.offerTypes.is_employee_offer = "N";
      if (event == "N") {
        this.offerSettingConfiguration.bankDetails = {
          selectedBank: "",
          selectedCard: "",
          bank_id: null,
          card_type_ids: null,
        };
      }
    },
    async getBankList() {
      try {
        let loader = this.$loading.show();
        const response = await MarketingService.GetActiveBanks();
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.activeBankList = data.Records;
          loader.hide();
        } else {
          this.$toasted.show(data.message || "Oops! Something went wrong");
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async onSelectBankv2(event) {
      this.offerSettingConfiguration.bankDetails["bank_id"] = null;
      this.offerSettingConfiguration.selectedCard = [];
      this.masterData.activeBankCardList = [];
      this.offerSettingConfiguration.bankDetails["bank_id"] = event["bank_id"];
      // this.offerSettingConfiguration.selectedCard = [];

      await this.getBankCards();
    },
    async getBankCards() {
      this.masterData.activeBankCardList = [];
      this.offerSettingConfiguration.bankDetails["selectedCard"] = [];
      let bankId =
        this.offerSettingConfiguration.bankDetails["bank_id"] || null;
      if (bankId) {
        try {
          const response = await MarketingService.GetActiveBanksCards(
            this.offerSettingConfiguration.bankDetails["bank_id"]
          );
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterData.activeBankCardList = data.Records;
          } else {
            this.$toasted.show(data.message || "Oops! Something went wrong");
          }
        } catch (error) {
          this._CatchError(error);
        }
      } else {
        this.masterData.activeBankCardList = [];
      }
    },
    handlePackageOfferChange(event) {
      if (event == "Y") {
        this.offerTypes.selectedOfferType = "buyAndGetCombo";
      }
    },
    checkOfferTypeAvailable(offerType) {
      if (this.offerTypes.is_employee_offer == "Y") {
        if (offerType == "fixedDiscount") {
          return true;
        } else {
          return false;
        }
      } else if (this.offer.is_package_offer == "Y") {
        return ["fixedPriceTicketFnb", "buyAndGetCombo"].includes(offerType);
      } else {
        return true;
      }
    },
    onChangeOfferType(event) {
      console.log("event", event);
      if (event == "buyAndGetFreeTickets") {
        this.redemptionOutlet.offer_redeem_at_concession = "N";
      } else if (event == "fixedPriceTicketFnb") {
        this.redemptionOutlet.offer_redeem_at_concession = "N";
      } else if (event == "buyAndgetOffOnAnother") {
        this.redemptionOutlet.offer_redeem_at_concession = "N";
      } else if (event == "fnbItemDiscounts") {
        this.redemptionOutlet.offer_redeem_at_boxoffice = "N";
        this.redemptionOutlet.offer_redeem_at_concession = "Y";
      }
    },
    onChangeChannelWise(event) {
      this.offerTypes.fixedDiscount.oc_min_fnb_price = 0;
    },
    async getFnBItems() {
      try {
        let loader = this.$loading.show();
        const response = await MarketingService.GetAllFNBItems();
        const { data } = response;
        if (data && data.status && data.Records && data.Records.length > 0) {
          this.masterData.fnbItems = data.Records;
          loader.hide();
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getUserList() {
      try {
        let loader = this.$loading.show();
        const response = await MarketingService.GETUSERLIST();
        const { data } = response;
        console.log("response------>", response);
        if (data && data.status && data.Records && data.Records.length > 0) {
          this.masterData.userList = data.Records;
          loader.hide();
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onChangeCount(event, offerType, type) {
      let value = event.target.value;
      if (offerType == "buyTicketFnbFixedPrice") {
        if (type == "buy") {
          this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction =
            value;
        } else if (type == "max") {
          if (
            value &&
            this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket &&
            parseInt(
              this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket
            ) > parseInt(value)
          ) {
            this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction =
              this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket;
            this.$toasted.show(
              "Max Limit Must be Greater or Equal to No. of Buy Tickets"
            );
            this.$forceUpdate();
          }
        }
      } else if (offerType == "buyAndgetOffOnAnother") {
        if (type == "buy") {
          this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction =
            value;
        } else if (type == "max") {
          if (
            value &&
            this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket &&
            parseInt(
              this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket
            ) > parseInt(value)
          ) {
            this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction =
              this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket;
            this.$toasted.show(
              "Max Limit Must be Greater or Equal to No. of Buy Tickets"
            );
            this.$forceUpdate();
          }
        }
      }
    },
    selectFnbItemFixedOffer(event, index, type) {
      if (type == "Add") {
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_id = event.item_id;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_code = event.item_code;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].selectedFnbItem = {
          item_id: event.item_id,
          item_name: event.item_name,
          item_code: event.item_code,
        };
      } else if (type == "Remove") {
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_id = null;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_code = "";
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].selectedFnbItem = "";
      }
      if (this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.length) {
        this.redemptionOutlet.offer_redeem_at_concession = "Y";
      } else {
        this.redemptionOutlet.offer_redeem_at_concession = "N";
      }
    },
    addFnbCriteria() {
      let fnbObj = {
        oc_buy_no_of_item: null,
        oc_buy_item_id: null,
        oc_buy_item_code: null,
        selectedFnbItem: "",
        oc_fnb_at_price: null,
      };
      this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.push(fnbObj);
    },
    removeFnbCriteria(index) {
      this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.splice(index, 1);
    },

    addFnbItemDiscountRow() {
      // const itemCodesToRemove = new Set(this.rejectedFnbItemCode);
      // console.log(
      //   "fnbItemsForFnbDiscount=>",
      //   this.fnbItemsForFnbDiscount.length
      // );

      // let nextRowItems = this.fnbItemsForFnbDiscount.map(category => {
      //   console.log("category.fnbItemsData=>", category.fnbItemsData);
      //   // Ensure category.fnbItemsData exists and is an array
      //   if (Array.isArray(category.fnbItemsData)) {
      //     // Return the modified category object with updated fnbItemsData
      //     category.fnbItemsData = category.fnbItemsData.filter(
      //       fnbItem => !itemCodesToRemove.has(fnbItem.item_code)
      //     );
      //   }
      //   return category;
      // });

      // console.log("this.offerTypes.fnbItemDiscounts=>",this.offerTypes.fnbItemDiscounts)
      this.offerTypes["fnbItemDiscounts"].push({
        selectedFnbItem: [],
        fnb_item_offer: null,
        fnbItemList: this.fnbItemsForFnbDiscount,
      });
    },
    removeFnbItemDiscountRow(rowIndex) {
      console.log("rowIndex=>", rowIndex);
      this.offerTypes.fnbItemDiscounts.splice(rowIndex, 1);
    },
    onChangeTabHandler: function (event, index) {
      this.offerContent.activeIndex = index;
    },
    CheckEmptyContent: function (Content, index) {
      if (Content.langauge.toLowerCase() !== "english") {
        if (Content.offer_title) {
          this.offerContent.notempty[index] = true;
        } else {
          this.offerContent.notempty[index] = false;
        }
      }
    },
    setModalData(height, width, contentIndex = null, type = 1) {
      console.log("type=>", type);
      this.offerContent.imageType = type;
      this.offerContent.bannerUpload = false;
      // this.$forceUpdate();
      this.offerContent.set_height = height;
      this.offerContent.set_width = width;
      this.offerContent.uploadIndex = contentIndex;
      this.offerContent.showModal = !this.offerContent.showModal;
      if (type == 3) {
        this.signageImageData.cropSizeEnable = false;
      } else {
        this.signageImageData.cropSizeEnable = true;
      }
      console.log("setmodl offetContent=>", this.offerContent);
    },
    onChangeTranslationInput(event, content, contentIndex, item) {
      this.CheckEmptyContent(content, contentIndex);
    },
    async getContentLangauge() {
      try {
        let loader = this.$loading.show();
        const response = await MovieService.GetMovieContentLanguages();
        const { data } = response;
        if (data && data.status && data.ContentLanguages.length) {
          this.masterData.ContentLanguages = data.ContentLanguages;
          data.ContentLanguages.forEach((x) => {
            let Obj = {
              ...x,
              offer_title: "",
              offer_description: "",
              offer_banner_image: "",
              offer_poster_image: "",
            };
            this.offerContent.offerContentArray.push(Obj);
          });
          loader.hide();
          console.log("this.ContentLanguages", this.ContentLanguages);
        } else {
          console.log("data.message :", data.message);
          loader.hide();
        }
        // this.makeLangContainers();
      } catch (error) {
        console.log("Catch Error :", error);
      }
    },
    onChangeReporting(event, type) {
      if (type == "full" || type == "full_spcl") {
        this.offerSettingConfiguration.o_reporting_percent = null;
        this.offerSettingConfiguration.has_o_reporting_percent = "N";
      } else if (type == "specific") {
        this.offerSettingConfiguration.report_full_amount_special_rc = "N";
        this.offerSettingConfiguration.report_full_amount = "N";
      }
    },
    onChangeText(event, type) {
      this.offerContent.offerContentArray.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.offer_title = event.target.value;
          } else if (type == "desc") {
            x.offer_description = event.target.value;
          }
        }
      });
    },
    async getCinemasList() {
      this.masterData.cinemasList = [];

      try {
        let loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        });
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.cinemasList = data.Records;
          this.offerContent.pg_promo_code = data.Records.map((c) => ({
            pg_promo_code: "",
            cine_id: c.cine_id,
            cine_name: c.cine_name,
          }));
          loader.hide();
        } else {
          this.$toasted.show(data.message || this.AdminError);
          loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async updateRejectedCinemaIds(settingsIndex, event, action) {
      console.log("cinema select", action, settingsIndex, event);
      if (action == "add") {
        this.cinemaSettingsSection.rejectedCinemaIds.push(event.cine_id);
        if (this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
            let cinemaIndex = -1;
            cinemaIndex = row.allowedCinemaList.findIndex(
              (list) => list.cine_id == event.cine_id
            );
            if (cinemaIndex >= 0) {
              row.allowedCinemaList.splice(cinemaIndex, 1);
            }
          });
        }
        // await this.getCinemawiseScreenList(settingsIndex)
      } else {
        let idIndex = this.cinemaSettingsSection.rejectedCinemaIds.indexOf(
          event.cine_id
        );
        if (idIndex >= 0) {
          this.cinemaSettingsSection.rejectedCinemaIds.splice(idIndex, 1);
        }
        //update screen list after remove cinema
        this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedScreens = this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedScreens.filter((screen) => screen.cinema_id != event.cine_id);

        if (this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
            let cinemaIndex = -1;
            cinemaIndex = row.allowedCinemaList.findIndex(
              (list) => list.cine_id == event.cine_id
            );
            if ((cinemaIndex = -1)) {
              row.allowedCinemaList.push(event);
            }
          });
        }
        // await this.getCinemawiseScreenList(settingsIndex)
      }
    },
    async updateScreenListCinemaWise(event, index) {
      let loader = this.$loading.show();
      try {
        let cinema_ids = [];

        if (event.length) {
          cinema_ids = event.map((cinema) => cinema.cine_id).join(",");

          console.log("cinema id arrau fetch function=>", cinema_ids);
          let payload = { cinema_ids };
          let response = await MarketingService.getCinemawiseScreenList(
            payload
          );
          const { data } = response;
          if (data.status && data.Records.length) {
            this.cinemaSettingsSection.cinemaSettings[index].allowedScreenList =
              data.Records;
          } else {
            console.log(data.message);
          }
        } else {
          this.cinemaSettingsSection.cinemaSettings[index].allowedScreenList =
            [];
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getCinemawiseScreenList(SettingIndex) {
      let loader = this.$loading.show();
      try {
        let cinema_ids = [];
        console.log(
          this.cinemaSettingsSection.cinemaSettings[SettingIndex]
            .selectedCinema,
          "this.cinemaSettingsSection.cinemaSettings[SettingIndex]"
        );
        if (
          this.cinemaSettingsSection.cinemaSettings[SettingIndex].selectedCinema
            .length
        ) {
          cinema_ids = this.cinemaSettingsSection.cinemaSettings[
            SettingIndex
          ].selectedCinema
            .map((cinema) => cinema.cine_id)
            .join(",");
        }

        let payload = { cinema_ids };
        let response = await MarketingService.getCinemawiseScreenList(payload);
        const { data } = response;
        if (data.status && data.Records.length) {
          this.cinemaSettingsSection.cinemaSettings[
            SettingIndex
          ].allowedScreenList = data.Records;
        } else {
          console.log(data.message);
        }
        loader.hide();
      } catch (error) {
        loader.hide();
        this._CatchError(error);
      }
    },
    downloadImageSignage(obj, index) {
      let imgPath = obj.imageUrl;
      let fileName = ``;
      let extension_array = imgPath.split(".");
      let actual_extension = extension_array[extension_array.length - 1];
      fileName = `Offer_Signage_${obj.width}x${obj.height}.${actual_extension}`;
      this._downloadImagePath(imgPath, fileName);
    },
    deleteImageSignage(index) {
      this.signageImageData.signageContainer[index].imageUrl = "";
    },
    removeSignage(index) {
      this.signageImageData.signageContainer.splice(index, 1);
    },
    addSignageData() {
      this.signageImageData.signageContainer.push({
        width: "",
        height: "",
        imageUrl: "",
      });
    },
    handleDistributorRowAction(type, index = null) {
      if (type === "add") {
        this.distributorSection.distributorData.push({
          selectedCinema: {},
          selectedSeatTypes: [],
          selectedTickets: [],
          pvds_dist_value: null,
        });
      } else {
        this.distributorSection.distributorData.splice(index, 1);
      }
    },
    async getCinemaList() {
      let loader = this.$loading.show();
      try {
        let payload = {
          reject_cinema_ids: this.cinemaSettingsSection.rejectedCinemaIds,
        };
        let response = await MarketingService.getCinemaList(payload);
        let { data } = response;
        if (data && data.status && data.Records.length) {
          loader.hide();
          this.masterData.cinemasList = data.Records;
          return data.Records;
        } else {
          loader.hide();
          console.log(data.message);
        }
      } catch (error) {
        loader.hide();
        this._CatchError(error);
      }
    },
    async OnFinalSubmit() {
      this.submitted = true;
      let validationResponse = this.validateOfferData();
      console.log("validationResponse=>", validationResponse);
      if (!validationResponse.status) {
        return this.$toasted.show(validationResponse.message);
      }
      if (
        this.voucherSelected &&
        (!this.voucherSettting.oc_total_redemptions ||
          !this.voucherSettting.oc_redemptions_per_patron)
      ) {
        return this.$toasted.show("Min 1 redemption patron needed");
      }
      this.$validator.validate().then(async (valid) => {
        if (valid) {
          if (
            moment(this.offer.offer_start_date_time, moment.ISO_8601).isAfter(
              moment(this.offer.offer_end_date_time, moment.ISO_8601)
            )
          ) {
            return this.$toasted.show("Please Enter Proper Dates");
          }

          if (
            this.offerMovieConfiguration.movies_applicable_status ==
              "movies_not_applicable" &&
            !this.offerMovieConfiguration.selectedParticaularMovies.length
          ) {
            return this.$toasted.show(
              "Please select atleast one applicable movie "
            );
          }

          //days validation
          if (this.offerDaysConfiguration.TrueFalseCount == 7) {
            return;
          }

          // cinema settings data
          if (this.cinemaSettingsSection.isCinemaSettingsApplicable == "Y") {
            let noCinemaIndex =
              this.cinemaSettingsSection.cinemaSettings.findIndex(
                (checkCinemaSetting) =>
                  !checkCinemaSetting.selectedCinema.length
              );
            if (noCinemaIndex >= 0)
              return this.$toasted.show(
                `Cinema Setting at ${noCinemaIndex} is missing`
              );
          }
          if (this.redemptionOutlet.selectedUsers.length == 0) {
            return this.$toasted.show(
              `select atleast one user for redemption outlet`
            );
          }
          this.btn_disable = true;
          let cinemaSettingsDataPayload = [];
          this.cinemaSettingsSection.cinemaSettings.forEach(
            (cinemaSettingsObj) => {
              let cinemaSettingPayloadObj = {
                all_cinema_id: cinemaSettingsObj.selectedCinema.length
                  ? cinemaSettingsObj.selectedCinema
                      .map((cinema) => cinema.cine_id)
                      .join(",")
                  : "",
                all_screen_ids: "",
                all_seat_group_type_id: "",
                all_tt_id: "",
                is_settings_applicable:
                  cinemaSettingsObj.is_settings_applicable,
              };

              if (cinemaSettingsObj.selectedScreens.length) {
                cinemaSettingPayloadObj["all_screen_ids"] =
                  cinemaSettingsObj.selectedScreens
                    .map((screensObj) => screensObj.screen_id)
                    .join(",");
              }

              if (cinemaSettingsObj.selectedTickets.length) {
                cinemaSettingPayloadObj["all_tt_id"] =
                  cinemaSettingsObj.selectedTickets
                    .map((ticketsObj) => ticketsObj.tt_id)
                    .join(",");
              }

              if (cinemaSettingsObj.selectedSeatTypes.length) {
                cinemaSettingPayloadObj["all_seat_group_type_id"] =
                  cinemaSettingsObj.selectedSeatTypes
                    .map((seatsGroupObj) => seatsGroupObj.sstg_id)
                    .join(",");
              }
              cinemaSettingsDataPayload.push(cinemaSettingPayloadObj);
            }
          );

          //offer validation

          let offersData = {
            //offer
            os_is_active: this.offer.os_is_active,
            offer_title: this.offer.offer_title,
            is_package_offer: this.offer.is_package_offer,
            report_offer: this.offer.report_offer,
            customers_only: this.offer.customers_only,
            auto_apply: this.offer.auto_apply,
            is_dynamic_voucher: this.offer.is_dynamic_voucher,
            offer_code: this.offer.offer_code,
            offer_group_type_id: this.offer.selectedOfferGroupType
              ? this.offer.selectedOfferGroupType.ogt_id
              : 1,
            // offer_start_date_time: moment(
            //   this.offer.offer_start_date_time
            // ).format("YYYY-MM-DD HH:mm"),
            // offer_end_date_time: moment(this.offer.offer_end_date_time).format(
            //   "YYYY-MM-DD HH:mm"
            // ),
            offer_start_date_time: `${moment(
              this.offer.offer_start_date_time
            ).format("YYYY-MM-DD")} ${
              this.offer.offer_start_time
                ? this.offer.offer_start_time
                : moment().format("HH:mm")
            }`,
            offer_end_date_time: `${moment(
              this.offer.offer_end_date_time
            ).format("YYYY-MM-DD")} ${
              this.offer.offer_end_time
                ? this.offer.offer_end_time
                : moment().format("HH:mm")
            }`,
            offer_start_time: this.offer.offer_start_time,
            offer_end_time: this.offer.offer_end_time,
            offer_description_text: this.offer.offer_description_text,
            //offfer Content
            pg_promo_code:
              this.offerContent.pg_promo_code.length > 0
                ? JSON.stringify(this.offerContent.pg_promo_code)
                : null,
            //movie config
            os_is_foreign_movie_applicable:
              this.offerMovieConfiguration.os_is_foreign_movie_applicable,
            os_movie_mf_id:
              this.offerMovieConfiguration.selectedMovieFormats.length > 0
                ? this.offerMovieConfiguration.selectedMovieFormats
                    .map((format) => format.mf_id)
                    .join(",")
                : "",
            os_is_movie_applicable:
              this.offerMovieConfiguration.os_is_movie_applicable,

            //days config
            offer_applicable_on_all_day:
              this.offerDaysConfiguration.offer_applicable_on_all_day,

            //offer split config
            client_id: this.offerSettingConfiguration.clientShareSettings.client
              ? this.offerSettingConfiguration.clientShareSettings.client
                  .client_id
              : null,
            client_share_value: this.offerSettingConfiguration
              .clientShareSettings.client_share_value
              ? this.offerSettingConfiguration.clientShareSettings
                  .client_share_value
              : null,
            client_share_is_percentage: this.offerSettingConfiguration
              .clientShareSettings.is_share_percentage
              ? this.offerSettingConfiguration.clientShareSettings
                  .is_share_percentage
              : this.offerSettingConfiguration.clientShareSettings
                  .is_prepaid_voucher == "Y"
              ? "N"
              : "Y",
            is_prepaid_voucher: this.offerSettingConfiguration
              .clientShareSettings.is_prepaid_voucher
              ? this.offerSettingConfiguration.clientShareSettings
                  .is_prepaid_voucher
              : "N",
            offer_dist_share_threshold:
              this.offerSplitConfiguration.offer_dist_share_threshold,
            //offersetting config
            is_bank_offer: this.offerSettingConfiguration.is_bank_offer,
            is_employee_offer: this.offerTypes.is_employee_offer,
            is_offer_auth_required: this.offer.is_offer_auth_required,
            visible_on_web: this.offer.visible_on_web,
            is_redemption: this.offer.is_redemption,
            report_full_amount:
              this.offerSettingConfiguration.report_full_amount,
            report_full_amount_special_rc:
              this.offerSettingConfiguration.report_full_amount_special_rc,
            has_o_reporting_percent:
              this.offerSettingConfiguration.has_o_reporting_percent,
            o_reporting_percent:
              this.offerSettingConfiguration.o_reporting_percent,

            //redemption outlet
            offer_redeem_at_online: "Y", //filtering now based on redemption_outlets
            offer_redeem_at_boxoffice:
              this.redemptionOutlet.offer_redeem_at_boxoffice,
            offer_redeem_at_concession:
              this.redemptionOutlet.offer_redeem_at_concession,
            offer_applicable_on_gross_amount:
              this.redemptionOutlet.offer_applicable_on_gross_amount,
            offer_applicable_on_net_amount:
              this.redemptionOutlet.offer_applicable_on_net_amount,
            redemption_outlets: this.redemptionOutlet.selectedUsers.length
              ? this.redemptionOutlet.selectedUsers
                  .map((user) => user.user_id)
                  .join(",")
              : "",
            //

            //signage imagedaata
            signage_image: this.signageImageData.signageContainer.length
              ? JSON.stringify(this.signageImageData.signageContainer)
              : "",
          };

          // voucher data
          let vouchersData = {
            ...this.voucherSettting,
            voucher_code: this.offer.offer_code,
          };
          let moviesData = {
            moviesDetails:
              this.offerMovieConfiguration.selectedParticaularMovies,
            start_show_time: this.offerMovieConfiguration.start_show_time,
            end_show_time: this.offerMovieConfiguration.end_show_time,
          };
          if (
            this.offerMovieConfiguration.os_time_limit_start &&
            this.offerMovieConfiguration.os_time_limit_end
          ) {
            moviesData = {
              ...moviesData,
              os_time_limit_start: `${this.offerMovieConfiguration.os_time_limit_start["HH"]}:${this.offerMovieConfiguration.os_time_limit_start["mm"]}`,
              os_time_limit_end: `${this.offerMovieConfiguration.os_time_limit_end["HH"]}:${this.offerMovieConfiguration.os_time_limit_end["mm"]}`,
            };
          }

          let bankOfferData = {
            bank_id: this.offerSettingConfiguration.bankDetails["bank_id"],
            cardType:
              this.offerSettingConfiguration.bankDetails.selectedCard.length > 0
                ? this.offerSettingConfiguration.bankDetails.selectedCard
                    .map((card) => card.card_id)
                    .join(",")
                : "",
          };

          let offersContentData = this.offerContent.offerContentArray;
          let daysData = this.offerDaysConfiguration.weekDays;

          let offerCriteriaData = {};
          switch (this.offerTypes.selectedOfferType) {
            case "fixedDiscount":
              offerCriteriaData = this.offerTypes.fixedDiscount;
              offerCriteriaData.offer_type_id = 8;
              offersData.offer_type_id = 8;

              break;
            case "buyAndGetFreeTickets":
              offerCriteriaData = this.offerTypes.buyAndGetFreeTickets;
              offerCriteriaData.offer_type_id = 1;
              offersData.offer_type_id = 1;

              break;
            case "discount":
              offerCriteriaData = this.offerTypes.discount;
              offerCriteriaData.offer_type_id = 2;
              offersData.offer_type_id = 2;
              break;
            case "loyalitycustomers":
              offerCriteriaData = this.offerTypes.loyalityProgramOffer;
              offerCriteriaData.offer_type_id = 7;
              offersData.offer_type_id = 1;

              break;
            case "buyAndGetCombo":
              if (
                this.offerTypes.buyAndGetCombo.offerApplicableAt == "boxOffice"
              ) {
                offerCriteriaData = this.offerTypes.buyAndGetCombo.boxOffice;
                if (
                  this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem
                ) {
                  offerCriteriaData.oc_get_item_count = 1; //buy 1 ticket and get certain fnb for free/price
                  offerCriteriaData.oc_get_item_id =
                    this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_id;
                  offerCriteriaData.oc_get_item_code =
                    this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_code;
                }
                offerCriteriaData.isBo = true;
                // offerCriteriaData = {
                //   ...offerCriteriaData,
                //   ...this.offerTypes.buyAndGetCombo.boxOffice,
                // };
              } else {
                offerCriteriaData = this.offerTypes.buyAndGetCombo.F_And_B;
                // offerCriteriaData.isBo = false;

                if (this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem) {
                  offerCriteriaData.oc_buy_item_id =
                    this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_id;
                  offerCriteriaData.oc_buy_item_code =
                    this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_code;
                  delete offerCriteriaData.selectedBuyFnbItem;
                }
                if (this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem) {
                  offerCriteriaData.oc_get_item_id =
                    this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_id;
                  offerCriteriaData.oc_get_item_code =
                    this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_code;
                  delete offerCriteriaData.selectedGetFnbItem;
                }
                offerCriteriaData.isBo = false;
              }
              offerCriteriaData.offer_type_id = 3;
              offersData.offer_type_id = 3;

              break;
            case "fixedPriceTicketFnb":
              offerCriteriaData = this.offerTypes.buyTicketFnbFixedPrice;
              offerCriteriaData.offer_type_id = 9;
              offersData.offer_type_id = 9;

              break;
            case "buyAndgetOffOnAnother":
              offerCriteriaData = this.offerTypes.buyAndgetOffOnAnother;
              offerCriteriaData.offer_type_id = 10;
              offersData.offer_type_id = 10;

              break;

            case "fnbItemDiscounts":
              offerCriteriaData = {
                // fnbDiscountData:
                //   this.offerTypes.fnbItemDiscounts.length > 0
                //     ? this.offerTypes.fnbItemDiscounts.map(item => {
                //         return {
                //           ...item.selectedFnbItem,
                //           item_offer_value: item.fnb_item_offer
                //         };
                //       })
                //     : []
                fnbDiscountData:
                  this.offerTypes.fnbItemDiscounts.length > 0
                    ? [
                        ...this.offerTypes.fnbItemDiscounts.flatMap((item) => {
                          return item.selectedFnbItem.map((fnbItem) => ({
                            ...fnbItem,
                            item_offer_value: item.fnb_item_offer,
                          }));
                        }),
                      ]
                    : [],
              };
              offerCriteriaData.offer_type_id = 11;
              offersData.offer_type_id = 11;

              break;
            case "freeTickets":
              offerCriteriaData = {
                freeTicketsCount: this.offerTypes.freeTickets.freeTicketCount,
                oc_max_no_of_ticket_per_transaction:
                  this.offerTypes.freeTickets.maxFreeeTicketCount,
                oc_max_discount_amount:
                  this.offerTypes.freeTickets.maxDiscountAmount,
                oc_min_no_of_ticket:
                  this.offerTypes.freeTickets.minFreeeTicketCount,
              };
              offerCriteriaData.offer_type_id = 12;
              offersData.offer_type_id = 12;
              break;

            case "onlyFnbFixed":
              const item_code =
                this.offerTypes.onlyFnbFixed.oc_buy_item_code["item_code"] ||
                null;
              const item_id =
                this.offerTypes.onlyFnbFixed.oc_buy_item_code["item_id"] ||
                null;
              if (!item_id || !item_code) {
                return this.$toasted.show("Select atleast one item");
              }
              if (
                !this.offerTypes.onlyFnbFixed
                  .oc_max_no_of_ticket_per_transaction
              ) {
                return this.$toasted.show("Buy item cannot be 0");
              }
              offerCriteriaData = {
                oc_buy_item_id: item_id,
                oc_buy_item_code: item_code,
                oc_buy_item_count:
                  this.offerTypes.onlyFnbFixed.oc_buy_item_count,
                oc_discount_value:
                  this.offerTypes.onlyFnbFixed.oc_discount_value,
                oc_max_no_of_ticket_per_transaction:
                  this.offerTypes.onlyFnbFixed
                    .oc_max_no_of_ticket_per_transaction,
              };
              offerCriteriaData.offer_type_id = 13;
              offersData.offer_type_id = 13;
              break;
          }
          offerCriteriaData.oc_redemptions_per_patron =
            this.voucherSettting.oc_redemptions_per_patron;
          offerCriteriaData.oc_total_redemptions =
            this.voucherSettting.oc_total_redemptions;

          let distributorShareData = this.distributorSection.distributorData
            .length
            ? this.distributorSection.distributorData.map((data) => {
                return {
                  pvds_all_seat_type_id: data.selectedSeatTypes.length
                    ? data.selectedSeatTypes
                        .map((seatType) => seatType.sstg_id)
                        .join(",")
                    : "",

                  pvds_ticket_type_id: data.selectedTickets.length
                    ? data.selectedTickets
                        .map((ticketType) => ticketType.tt_id)
                        .join(",")
                    : "",

                  pvds_dist_value: data.pvds_dist_value,
                  pvds_cinema_id: data.selectedCinema
                    ? data.selectedCinema.cine_id
                    : null,
                };
              })
            : [];

          let payload = {
            isVoucher: this.voucherSelected,
            offersData,
            offersContentData,
            moviesData,
            daysData,
            bankOfferData,
            offerCriteriaData,
            vouchersData,
            distributorShareData,
            cinemaSettings: cinemaSettingsDataPayload,
          };
          console.log("payload=>", payload);
          let loader = this.$loading.show();

          try {
            let response = await MarketingService.addOfferVoucherNew(payload);
            let { data } = response;
            if (data && data.status) {
              this.btn_disable = false;

              console.log(data);
              loader.hide();
              this.$toasted.show(data.message);
              this.$router.push({
                path: "/marketing/promotions-and-offers",
              });
            } else {
              loader.hide();
              this.btn_disable = false;
              console.log(data.message);
            }
          } catch (error) {
            loader.hide();
            this.btn_disable = false;
            this._CatchError(error);
          }
        }
      });
    },
    async getFnBItemsForFnbDiscountOfferType() {
      try {
        // let loader = this.$loading.show();
        const response =
          await MarketingService.getFnbItemsForFnbDiscountsOfferType();
        const { data } = response;
        if (data && data.status && data.Records && data.Records.length > 0) {
          // this.masterData.fnbItems = data.Records;
          this.originalFnbItemForFnbDiscount = data.Records;
          const groupedData = _.groupBy(data.Records, "fc_id");

          const transformedData = Object.keys(groupedData).map((fc_id) => {
            const items = groupedData[fc_id];
            return {
              fc_id: parseInt(fc_id),
              fc_name: items[0].fc_category,
              fnbItemsData: items,
            };
          });
          this.fnbItemsForFnbDiscount = transformedData;
          const { fnbItemDiscounts } = this.offerTypes;
          fnbItemDiscounts[0].fnbItemList = transformedData;
          console.log("fnbItemDiscounts=>", fnbItemDiscounts);
          // this.offerTypes["fnbItemDiscounts"][0]["fnbItemList"]=transformedData

          // console.log("this.offerType.fnbItemDiscounts=>",this.offerType.fnbItemDiscounts)
          // this.offerType.fnbItemDiscounts[0].fnbItemList=transformedData

          // loader.hide();
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
          // loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    handleAllRowNotApplicableStatus(event) {
      console.log("event=>", event);
      this.cinemaSettingsSection.cinemaSettings.forEach((cinemaRow) => {
        cinemaRow.is_settings_applicable = event;

        if (event == "N" && cinemaRow["selectedScreens"].length > 0) {
          cinemaRow["selectedScreens"] = [];
        }
        if (event == "N" && cinemaRow["selectedSeatTypes"].length > 0) {
          cinemaRow["selectedSeatTypes"] = [];
        }
      });
    },

    updateFnbList: function (index, event, type) {
      if (type === "add") {
        if (event.length) {
          const itemCodes = event.map((item) => item.item_code);

          for (const [index, row] of this.offerTypes[
            "fnbItemDiscounts"
          ].entries()) {
            const isItemCodePresent = row.selectedFnbItem.some((selectedItem) =>
              itemCodes.includes(selectedItem.item_code)
            );

            if (isItemCodePresent) {
              return this.$toasted.show(
                `Some Items already selected in row ${index + 1}`
              );
            } else {
              console.log(`Item code not found in row ${index}`);
            }
          }
          this.offerTypes["fnbItemDiscounts"][index]["selectedFnbItem"].push(
            ...event
          );
          this.rejectedFnbItemCode.push(...itemCodes);
        } else {
          const itemCode = event.item_code;
          for (const [index, row] of this.offerTypes[
            "fnbItemDiscounts"
          ].entries()) {
            const isItemCodePresent = row.selectedFnbItem.some(
              (selectedItem) => selectedItem.item_code === itemCode
            );

            if (isItemCodePresent) {
              //     this.offerTypes["fnbItemDiscounts"][index][
              //   "selectedFnbItem"
              // ]=  this.offerTypes["fnbItemDiscounts"][index][
              //   "selectedFnbItem"
              // ].filter(item=>item.item_code!=itemCode)
              return this.$toasted.show(
                `Items already selected in row ${index + 1}`
              );
            } else {
              console.log(`Item code not found in row ${index}`);
            }
          }
          const isItemCodePresent = this.offerTypes["fnbItemDiscounts"][index][
            "selectedFnbItem"
          ].some((item) => item.item_code === itemCode);

          if (!isItemCodePresent) {
            // If the itemCode is not present, push the event
            this.offerTypes["fnbItemDiscounts"][index]["selectedFnbItem"].push(
              event
            );
          }

          this.rejectedFnbItemCode.push(itemCode);
        }
      } else if (type === "remove") {
        if (Array.isArray(event) && event.length) {
          const itemCodes = event.map((item) => item.item_code);
          this.rejectedFnbItemCode = this.rejectedFnbItemCode.filter(
            (code) => !itemCodes.includes(code)
          );
          this.offerTypes["fnbItemDiscounts"][index]["selectedFnbItem"] =
            this.offerTypes["fnbItemDiscounts"][index][
              "selectedFnbItem"
            ].filter((item) => !itemCodes.includes(item.item_code));
        } else {
          const itemCode = event.item_code;
          this.rejectedFnbItemCode = this.rejectedFnbItemCode.filter(
            (code) => code !== itemCode
          );
          this.offerTypes["fnbItemDiscounts"][index]["selectedFnbItem"] =
            this.offerTypes["fnbItemDiscounts"][index][
              "selectedFnbItem"
            ].filter((item) => item.item_code != itemCode);
        }
      }
    },

    validateOfferData() {
      let returnObject = { status: true, message: "" };
      console.log("check validateOfferData");
      const {
        fixedDiscount,
        buyAndGetFreeTickets,
        discount,
        loyalityProgramOffer,
        buyAndGetCombo,
        buyTicketFnbFixedPrice,
        buyAndgetOffOnAnother,
        fnbItemDiscounts,
        selectedOfferType,
      } = this.offerTypes;

      if (selectedOfferType == "fixedPriceTicketFnb") {
        if (buyTicketFnbFixedPrice.oc_is_combo_with_fnb == "Y") {
          console.log(
            "buyTicketFnbFixedPrice.fnb_group_data=>",
            buyTicketFnbFixedPrice.fnb_group_data
          );

          for (const x of buyTicketFnbFixedPrice.fnb_group_data) {
            console.log("check item=>", x.selectedFnbItem.item_id);

            if (
              !x.selectedFnbItem ||
              !x.selectedFnbItem.hasOwnProperty("item_id")
            ) {
              return {
                status: false,
                message: "Please select F&B item for the selected offer type",
              };
            } else if (!x.oc_buy_no_of_item) {
              return {
                status: false,
                message: "Please enter buy number of items",
              };
            } else if (!x.oc_fnb_at_price) {
              return {
                status: false,
                message: "Please enter buy item price",
              };
            }
          }
        }
      }
      if (
        selectedOfferType == "buyAndGetFreeTickets" &&
        buyAndGetFreeTickets.oc_get_free_ticket >
          buyAndGetFreeTickets.oc_max_no_of_ticket_per_transaction
      ) {
        return {
          status: false,
          message:
            "Maximum Number of free tickets Must be greater and Offer Free ticket",
        };
      }
      if (
        selectedOfferType == "buyAndGetCombo" &&
        buyAndGetCombo.offerApplicableAt === "fAndb"
      ) {
        if (
          !buyAndGetCombo.F_And_B.selectedBuyFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, message: "select buy fnb item" };
        }
        if (
          !buyAndGetCombo.F_And_B.selectedGetFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, message: "select get fnb item" };
        }
      }
      if (
        selectedOfferType == "buyAndGetCombo" &&
        buyAndGetCombo.offerApplicableAt === "boxOffice"
      ) {
        console.log("check ");
        if (
          !buyAndGetCombo.boxOffice.selectedGetFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, message: "select get fnb item" };
        }
      }
      if (selectedOfferType == "fnbItemDiscounts" && fnbItemDiscounts.length) {
        console.log("validation start=>");
        // fnbItemDiscounts.forEach(item => {
        //   console.log("row=>",item)
        //   if (!item.selectedFnbItem.length ||!String(item.fnb_item_offer).length) {
        //     console.log("validation failed for row",row)
        //     return {
        //       status: false,
        //       message: "select fnb item and enter discount value for fnbItemDiscounts offer"
        //     };
        //   }
        //   // if (!item.fnb_item_offer) {
        //   //   console.log("find ele=>")
        //   //   return {
        //   //     status: false,
        //   //     message: "enter discount value for all row"
        //   //   };
        //   // }
        // });
        for (const item of fnbItemDiscounts) {
          console.log("row 1=>", item);

          if (!item.selectedFnbItem.length) {
            console.log("validation failed for row", item);
            return {
              status: false,
              message: "Select F&B item for fnbItemDiscounts offer ",
            };
          }
          if (!item.fnb_item_offer) {
            console.log("validation failed for row `", item);

            return {
              status: false,
              message: "enter disocunt value for fnbItemDiscounts offer",
            };
          }
        }
      }

      if (this.offerSettingConfiguration.is_bank_offer == "Y") {
        console.log(
          "is bank offer",
          this.offerSettingConfiguration.bankDetails
        );
        if (!this.offerSettingConfiguration.bankDetails.selectedBank) {
          return { status: false, message: "select bank for bank offer" };
        }
      }
      if (this.offerSettingConfiguration.is_bank_offer == "Y") {
        console.log("is bank offer");
        if (!this.offerSettingConfiguration.bankDetails.selectedCard.length) {
          return { status: false, message: "select card type" };
        }
      }

      return { status: true, message: "" };
    },
  },
  dataGroupingForFnbItem(data) {
    if (!data.length) {
      return [];
    }
    const groupedData = _.groupBy(data, "fc_id");

    const transformedData = Object.keys(groupedData).map((fc_id) => {
      const items = groupedData[fc_id];
      return {
        fc_id: parseInt(fc_id), // Convert fc_id to a number if needed
        fc_name: items[0].fc_category, // Assuming fc_name is the same for all items in the group
        fnbItemsData: items, // The grouped items
      };
    });
    return transformedData;
  },

  getFilteredOptions(rowIndex) {
    // Get all selected items from other rows
    const selectedItems = _.flatten(
      this.offerTypes.fnbItemDiscounts
        .filter((_, index) => index !== rowIndex) // Exclude the current row
        .map((row) => row.selectedFnbItem)
    );

    // Filter each category's items
    return this.fcData.map((category) => ({
      ...category,
      fnbItemsData: category.fnbItemsData.filter(
        (item) => !selectedItems.some((selected) => selected.id === item.id)
      ),
    }));
  },
};
</script>
<style>
.rowBackground {
  background: #e9ecef;
  padding: 8px;
  border-radius: 10px;
  zoom: 0.9;
}

.greyBackground {
  background-color: #e9ecef;
  border-radius: 15px;
}

.whiteBackground {
  background-color: white;
  border-radius: 15px;
}

.container {
  position: relative;
  padding: 40px;
  margin-top: 30px;
  border: 1px solid #3876d2;
}

.heading {
  position: absolute;
  top: -0.5em;
  left: 30px;
  margin: 0;
  background: white;
  padding: 0 10px;
  color: #3876d2;
  font-weight: bold;
}

.manual_bill_item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.bg-lightprimary {
  background-color: #3876d217;
}

.manual_bill_input input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

.manual_bill_input input::placeholder,
.manual_bill_wrapper .multiselect__placeholder {
  font-size: 12px;
  font-style: italic;
}

.subheading-scoped {
  position: absolute;
  top: -0.5em;
  left: 30px;
  margin: 0;
  background: white;
  padding: 0 10px;
  color: #3876d2;
  font-weight: bold;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/addPromotionsAndOffersNew.vue